/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as DeviceRouteImport } from './routes/device'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as SuspendedRouteImport } from './routes/suspended'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedWhatsNewRouteImport } from './routes/_authenticated/whats-new'
import { Route as AuthJoinRouteImport } from './routes/auth/join'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthOauthRouteImport } from './routes/auth/oauth'
import { Route as AuthRecoverRouteImport } from './routes/auth/recover'
import { Route as AuthResetRouteImport } from './routes/auth/reset'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthStartSignupRouteImport } from './routes/auth/start-signup'
import { Route as OpenArtifactArtifactIdRouteImport } from './routes/open-artifact.$artifactId'
import { Route as SharedTokenRouteImport } from './routes/shared.$token'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedDashboardArtifactsRouteImport } from './routes/_authenticated/dashboard/artifacts'
import { Route as AuthenticatedDashboardAuditLogsRouteImport } from './routes/_authenticated/dashboard/audit-logs'
import { Route as AuthenticatedDashboardComplianceRouteImport } from './routes/_authenticated/dashboard/compliance'
import { Route as AuthenticatedDashboardFeedbackRouteImport } from './routes/_authenticated/dashboard/feedback'
import { Route as AuthenticatedDashboardIntegrationsRouteImport } from './routes/_authenticated/dashboard/integrations'
import { Route as AuthenticatedDashboardMembersRouteImport } from './routes/_authenticated/dashboard/members'
import { Route as AuthenticatedDashboardSubscriptionRouteImport } from './routes/_authenticated/dashboard/subscription'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedProfileConnectionsRouteImport } from './routes/_authenticated/profile/connections'
import { Route as AuthenticatedProfilePreferencesRouteImport } from './routes/_authenticated/profile/preferences'
import { Route as AuthenticatedProfilePresentationTemplatesRouteImport } from './routes/_authenticated/profile/presentation-templates'
import { Route as AuthenticatedProfileSecurityRouteImport } from './routes/_authenticated/profile/security'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedSettingsAuditLogsRouteImport } from './routes/_authenticated/settings/audit-logs'
import { Route as AuthenticatedSettingsComplianceRouteImport } from './routes/_authenticated/settings/compliance'
import { Route as AuthenticatedSettingsConnectionsRouteImport } from './routes/_authenticated/settings/connections'
import { Route as AuthenticatedSettingsIntegrationsRouteImport } from './routes/_authenticated/settings/integrations'
import { Route as AuthenticatedSettingsMemoryRouteImport } from './routes/_authenticated/settings/memory'
import { Route as AuthenticatedSettingsOrgRouteRouteImport } from './routes/_authenticated/settings/org/route'
import { Route as AuthenticatedSettingsPreferencesRouteImport } from './routes/_authenticated/settings/preferences'
import { Route as AuthenticatedSettingsPresentationTemplatesRouteImport } from './routes/_authenticated/settings/presentation-templates'
import { Route as AuthenticatedSettingsSecurityRouteImport } from './routes/_authenticated/settings/security'
import { Route as AuthenticatedDashboardAdminIndexRouteImport } from './routes/_authenticated/dashboard/admin/index'
import { Route as AuthenticatedDashboardAdminAgentsRouteImport } from './routes/_authenticated/dashboard/admin/agents'
import { Route as AuthenticatedDashboardAdminIntegrationsRouteImport } from './routes/_authenticated/dashboard/admin/integrations'
import { Route as AuthenticatedDashboardAdminPresentationTemplatesRouteImport } from './routes/_authenticated/dashboard/admin/presentation-templates'
import { Route as AuthenticatedDashboardAdminPrivateModelsRouteImport } from './routes/_authenticated/dashboard/admin/private-models'
import { Route as AuthenticatedDashboardAdminRightsRouteImport } from './routes/_authenticated/dashboard/admin/rights'
import { Route as AuthenticatedDashboardAdminScimRouteImport } from './routes/_authenticated/dashboard/admin/scim'
import { Route as AuthenticatedDashboardAdminUnoRouteImport } from './routes/_authenticated/dashboard/admin/uno'
import { Route as AuthenticatedDashboardAgentsIndexRouteImport } from './routes/_authenticated/dashboard/agents/index'
import { Route as AuthenticatedDashboardAgentsAgentIdRouteRouteImport } from './routes/_authenticated/dashboard/agents/$agentId/route'
import { Route as AuthenticatedDashboardAgentsApprovalsRouteImport } from './routes/_authenticated/dashboard/agents/approvals'
import { Route as AuthenticatedDashboardAgentsNewRouteImport } from './routes/_authenticated/dashboard/agents/new'
import { Route as AuthenticatedDashboardAgentsTemplatesRouteImport } from './routes/_authenticated/dashboard/agents/templates'
import { Route as AuthenticatedDashboardChatsIndexRouteImport } from './routes/_authenticated/dashboard/chats.index'
import { Route as AuthenticatedDashboardChatsChatIdRouteImport } from './routes/_authenticated/dashboard/chats.$chatId'
import { Route as AuthenticatedDashboardDatasetsIndexRouteImport } from './routes/_authenticated/dashboard/datasets/index'
import { Route as AuthenticatedDashboardDatasetsSpaceIdRouteImport } from './routes/_authenticated/dashboard/datasets/$spaceId'
import { Route as AuthenticatedDashboardProjectsIndexRouteImport } from './routes/_authenticated/dashboard/projects/index'
import { Route as AuthenticatedDashboardProjectsProjectIdRouteRouteImport } from './routes/_authenticated/dashboard/projects/$projectId/route'
import { Route as AuthenticatedDashboardSpacesIndexRouteImport } from './routes/_authenticated/dashboard/spaces/index'
import { Route as AuthenticatedDashboardSpacesSpaceIdRouteImport } from './routes/_authenticated/dashboard/spaces/$spaceId'
import { Route as AuthenticatedDashboardTeamsIndexRouteImport } from './routes/_authenticated/dashboard/teams/index'
import { Route as AuthenticatedDashboardTeamsTeamIdRouteImport } from './routes/_authenticated/dashboard/teams/$teamId'
import { Route as AuthenticatedSettingsOrgAgentPolicyRouteImport } from './routes/_authenticated/settings/org/agent-policy'
import { Route as AuthenticatedSettingsOrgAgentsRouteImport } from './routes/_authenticated/settings/org/agents'
import { Route as AuthenticatedSettingsOrgIntegrationsRouteImport } from './routes/_authenticated/settings/org/integrations'
import { Route as AuthenticatedSettingsOrgModelsRouteImport } from './routes/_authenticated/settings/org/models'
import { Route as AuthenticatedSettingsOrgOverviewRouteImport } from './routes/_authenticated/settings/org/overview'
import { Route as AuthenticatedSettingsOrgPresentationTemplatesRouteImport } from './routes/_authenticated/settings/org/presentation-templates'
import { Route as AuthenticatedSettingsOrgPrivateModelsRouteImport } from './routes/_authenticated/settings/org/private-models'
import { Route as AuthenticatedSettingsOrgRightsRouteImport } from './routes/_authenticated/settings/org/rights'
import { Route as AuthenticatedSettingsOrgScimRouteImport } from './routes/_authenticated/settings/org/scim'
import { Route as AuthenticatedSettingsOrgSubscriptionRouteImport } from './routes/_authenticated/settings/org/subscription'
import { Route as AuthenticatedSettingsOrgUnoRouteImport } from './routes/_authenticated/settings/org/uno'
import { Route as AuthenticatedSettingsPersonasIndexRouteImport } from './routes/_authenticated/settings/personas/index'
import { Route as AuthenticatedSettingsPersonasStoreRouteImport } from './routes/_authenticated/settings/personas/store'
import { Route as AuthenticatedSettingsTeamsIndexRouteImport } from './routes/_authenticated/settings/teams/index'
import { Route as AuthenticatedSettingsTeamsTeamIdRouteImport } from './routes/_authenticated/settings/teams/$teamId'
import { Route as AuthenticatedDashboardAgentsAgentIdIndexRouteImport } from './routes/_authenticated/dashboard/agents/$agentId/index'
import { Route as AuthenticatedDashboardAgentsAgentIdEditRouteImport } from './routes/_authenticated/dashboard/agents/$agentId/edit'
import { Route as AuthenticatedDashboardAgentsAgentIdScheduleRouteImport } from './routes/_authenticated/dashboard/agents/$agentId/schedule'
import { Route as AuthenticatedDashboardAgentsAgentIdTriggersRouteImport } from './routes/_authenticated/dashboard/agents/$agentId/triggers'
import { Route as AuthenticatedDashboardProjectsProjectIdIndexRouteImport } from './routes/_authenticated/dashboard/projects/$projectId/index'
import { Route as AuthenticatedDashboardProjectsProjectIdAppsRouteImport } from './routes/_authenticated/dashboard/projects/$projectId/apps'
import { Route as AuthenticatedDashboardProjectsProjectIdArtifactsRouteImport } from './routes/_authenticated/dashboard/projects/$projectId/artifacts'
import { Route as AuthenticatedDashboardProjectsProjectIdChatsRouteImport } from './routes/_authenticated/dashboard/projects/$projectId/chats'
import { Route as AuthenticatedDashboardProjectsProjectIdDashboardsRouteImport } from './routes/_authenticated/dashboard/projects/$projectId/dashboards'
import { Route as AuthenticatedDashboardProjectsProjectIdFilesRouteImport } from './routes/_authenticated/dashboard/projects/$projectId/files'
import { Route as AuthenticatedSettingsOrgMembersIndexRouteImport } from './routes/_authenticated/settings/org/members/index'
import { Route as AuthenticatedSettingsOrgMembersUserIdRouteRouteImport } from './routes/_authenticated/settings/org/members/$userId/route'
import { Route as AuthenticatedDashboardAgentsAgentIdRunsIndexRouteImport } from './routes/_authenticated/dashboard/agents/$agentId/runs/index'
import { Route as AuthenticatedDashboardAgentsAgentIdRunsRunIdRouteImport } from './routes/_authenticated/dashboard/agents/$agentId/runs/$runId'
import { Route as AuthenticatedSettingsOrgMembersUserIdIndexRouteImport } from './routes/_authenticated/settings/org/members/$userId/index'
import { Route as AuthenticatedSettingsOrgMembersUserIdAuditRouteImport } from './routes/_authenticated/settings/org/members/$userId/audit'
import { Route as AuthenticatedSettingsOrgMembersUserIdProjectsRouteImport } from './routes/_authenticated/settings/org/members/$userId/projects'
import { Route as AuthenticatedSettingsOrgMembersUserIdSpacesRouteImport } from './routes/_authenticated/settings/org/members/$userId/spaces'
import { Route as AuthenticatedSettingsOrgMembersUserIdUsageRouteImport } from './routes/_authenticated/settings/org/members/$userId/usage'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceRoute = DeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const SuspendedRoute = SuspendedRouteImport.update({
  id: '/suspended',
  path: '/suspended',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWhatsNewRoute = AuthenticatedWhatsNewRouteImport.update({
  id: '/whats-new',
  path: '/whats-new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthJoinRoute = AuthJoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOauthRoute = AuthOauthRouteImport.update({
  id: '/oauth',
  path: '/oauth',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRecoverRoute = AuthRecoverRouteImport.update({
  id: '/recover',
  path: '/recover',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetRoute = AuthResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthStartSignupRoute = AuthStartSignupRouteImport.update({
  id: '/start-signup',
  path: '/start-signup',
  getParentRoute: () => AuthRouteRoute,
} as any)
const OpenArtifactArtifactIdRoute = OpenArtifactArtifactIdRouteImport.update({
  id: '/open-artifact/$artifactId',
  path: '/open-artifact/$artifactId',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedTokenRoute = SharedTokenRouteImport.update({
  id: '/shared/$token',
  path: '/shared/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardArtifactsRoute =
  AuthenticatedDashboardArtifactsRouteImport.update({
    id: '/dashboard/artifacts',
    path: '/dashboard/artifacts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAuditLogsRoute =
  AuthenticatedDashboardAuditLogsRouteImport.update({
    id: '/dashboard/audit-logs',
    path: '/dashboard/audit-logs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardComplianceRoute =
  AuthenticatedDashboardComplianceRouteImport.update({
    id: '/dashboard/compliance',
    path: '/dashboard/compliance',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardFeedbackRoute =
  AuthenticatedDashboardFeedbackRouteImport.update({
    id: '/dashboard/feedback',
    path: '/dashboard/feedback',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardIntegrationsRoute =
  AuthenticatedDashboardIntegrationsRouteImport.update({
    id: '/dashboard/integrations',
    path: '/dashboard/integrations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardMembersRoute =
  AuthenticatedDashboardMembersRouteImport.update({
    id: '/dashboard/members',
    path: '/dashboard/members',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardSubscriptionRoute =
  AuthenticatedDashboardSubscriptionRouteImport.update({
    id: '/dashboard/subscription',
    path: '/dashboard/subscription',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfileConnectionsRoute =
  AuthenticatedProfileConnectionsRouteImport.update({
    id: '/profile/connections',
    path: '/profile/connections',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfilePreferencesRoute =
  AuthenticatedProfilePreferencesRouteImport.update({
    id: '/profile/preferences',
    path: '/profile/preferences',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfilePresentationTemplatesRoute =
  AuthenticatedProfilePresentationTemplatesRouteImport.update({
    id: '/profile/presentation-templates',
    path: '/profile/presentation-templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfileSecurityRoute =
  AuthenticatedProfileSecurityRouteImport.update({
    id: '/profile/security',
    path: '/profile/security',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAuditLogsRoute =
  AuthenticatedSettingsAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsComplianceRoute =
  AuthenticatedSettingsComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsConnectionsRoute =
  AuthenticatedSettingsConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsIntegrationsRoute =
  AuthenticatedSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsMemoryRoute =
  AuthenticatedSettingsMemoryRouteImport.update({
    id: '/memory',
    path: '/memory',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsOrgRouteRoute =
  AuthenticatedSettingsOrgRouteRouteImport.update({
    id: '/org',
    path: '/org',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsPreferencesRoute =
  AuthenticatedSettingsPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsPresentationTemplatesRoute =
  AuthenticatedSettingsPresentationTemplatesRouteImport.update({
    id: '/presentation-templates',
    path: '/presentation-templates',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsSecurityRoute =
  AuthenticatedSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedDashboardAdminIndexRoute =
  AuthenticatedDashboardAdminIndexRouteImport.update({
    id: '/dashboard/admin/',
    path: '/dashboard/admin/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAdminAgentsRoute =
  AuthenticatedDashboardAdminAgentsRouteImport.update({
    id: '/dashboard/admin/agents',
    path: '/dashboard/admin/agents',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAdminIntegrationsRoute =
  AuthenticatedDashboardAdminIntegrationsRouteImport.update({
    id: '/dashboard/admin/integrations',
    path: '/dashboard/admin/integrations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAdminPresentationTemplatesRoute =
  AuthenticatedDashboardAdminPresentationTemplatesRouteImport.update({
    id: '/dashboard/admin/presentation-templates',
    path: '/dashboard/admin/presentation-templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAdminPrivateModelsRoute =
  AuthenticatedDashboardAdminPrivateModelsRouteImport.update({
    id: '/dashboard/admin/private-models',
    path: '/dashboard/admin/private-models',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAdminRightsRoute =
  AuthenticatedDashboardAdminRightsRouteImport.update({
    id: '/dashboard/admin/rights',
    path: '/dashboard/admin/rights',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAdminScimRoute =
  AuthenticatedDashboardAdminScimRouteImport.update({
    id: '/dashboard/admin/scim',
    path: '/dashboard/admin/scim',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAdminUnoRoute =
  AuthenticatedDashboardAdminUnoRouteImport.update({
    id: '/dashboard/admin/uno',
    path: '/dashboard/admin/uno',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAgentsIndexRoute =
  AuthenticatedDashboardAgentsIndexRouteImport.update({
    id: '/dashboard/agents/',
    path: '/dashboard/agents/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAgentsAgentIdRouteRoute =
  AuthenticatedDashboardAgentsAgentIdRouteRouteImport.update({
    id: '/dashboard/agents/$agentId',
    path: '/dashboard/agents/$agentId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAgentsApprovalsRoute =
  AuthenticatedDashboardAgentsApprovalsRouteImport.update({
    id: '/dashboard/agents/approvals',
    path: '/dashboard/agents/approvals',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAgentsNewRoute =
  AuthenticatedDashboardAgentsNewRouteImport.update({
    id: '/dashboard/agents/new',
    path: '/dashboard/agents/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAgentsTemplatesRoute =
  AuthenticatedDashboardAgentsTemplatesRouteImport.update({
    id: '/dashboard/agents/templates',
    path: '/dashboard/agents/templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardChatsIndexRoute =
  AuthenticatedDashboardChatsIndexRouteImport.update({
    id: '/dashboard/chats/',
    path: '/dashboard/chats/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardChatsChatIdRoute =
  AuthenticatedDashboardChatsChatIdRouteImport.update({
    id: '/dashboard/chats/$chatId',
    path: '/dashboard/chats/$chatId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardDatasetsIndexRoute =
  AuthenticatedDashboardDatasetsIndexRouteImport.update({
    id: '/dashboard/datasets/',
    path: '/dashboard/datasets/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardDatasetsSpaceIdRoute =
  AuthenticatedDashboardDatasetsSpaceIdRouteImport.update({
    id: '/dashboard/datasets/$spaceId',
    path: '/dashboard/datasets/$spaceId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardProjectsIndexRoute =
  AuthenticatedDashboardProjectsIndexRouteImport.update({
    id: '/dashboard/projects/',
    path: '/dashboard/projects/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardProjectsProjectIdRouteRoute =
  AuthenticatedDashboardProjectsProjectIdRouteRouteImport.update({
    id: '/dashboard/projects/$projectId',
    path: '/dashboard/projects/$projectId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardSpacesIndexRoute =
  AuthenticatedDashboardSpacesIndexRouteImport.update({
    id: '/dashboard/spaces/',
    path: '/dashboard/spaces/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardSpacesSpaceIdRoute =
  AuthenticatedDashboardSpacesSpaceIdRouteImport.update({
    id: '/dashboard/spaces/$spaceId',
    path: '/dashboard/spaces/$spaceId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardTeamsIndexRoute =
  AuthenticatedDashboardTeamsIndexRouteImport.update({
    id: '/dashboard/teams/',
    path: '/dashboard/teams/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardTeamsTeamIdRoute =
  AuthenticatedDashboardTeamsTeamIdRouteImport.update({
    id: '/dashboard/teams/$teamId',
    path: '/dashboard/teams/$teamId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsOrgAgentPolicyRoute =
  AuthenticatedSettingsOrgAgentPolicyRouteImport.update({
    id: '/agent-policy',
    path: '/agent-policy',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedSettingsOrgAgentsRoute =
  AuthenticatedSettingsOrgAgentsRouteImport.update({
    id: '/agents',
    path: '/agents',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedSettingsOrgIntegrationsRoute =
  AuthenticatedSettingsOrgIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedSettingsOrgModelsRoute =
  AuthenticatedSettingsOrgModelsRouteImport.update({
    id: '/models',
    path: '/models',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedSettingsOrgOverviewRoute =
  AuthenticatedSettingsOrgOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedSettingsOrgPresentationTemplatesRoute =
  AuthenticatedSettingsOrgPresentationTemplatesRouteImport.update({
    id: '/presentation-templates',
    path: '/presentation-templates',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedSettingsOrgPrivateModelsRoute =
  AuthenticatedSettingsOrgPrivateModelsRouteImport.update({
    id: '/private-models',
    path: '/private-models',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedSettingsOrgRightsRoute =
  AuthenticatedSettingsOrgRightsRouteImport.update({
    id: '/rights',
    path: '/rights',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedSettingsOrgScimRoute =
  AuthenticatedSettingsOrgScimRouteImport.update({
    id: '/scim',
    path: '/scim',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedSettingsOrgSubscriptionRoute =
  AuthenticatedSettingsOrgSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedSettingsOrgUnoRoute =
  AuthenticatedSettingsOrgUnoRouteImport.update({
    id: '/uno',
    path: '/uno',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedSettingsPersonasIndexRoute =
  AuthenticatedSettingsPersonasIndexRouteImport.update({
    id: '/personas/',
    path: '/personas/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsPersonasStoreRoute =
  AuthenticatedSettingsPersonasStoreRouteImport.update({
    id: '/personas/store',
    path: '/personas/store',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsTeamsIndexRoute =
  AuthenticatedSettingsTeamsIndexRouteImport.update({
    id: '/teams/',
    path: '/teams/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsTeamsTeamIdRoute =
  AuthenticatedSettingsTeamsTeamIdRouteImport.update({
    id: '/teams/$teamId',
    path: '/teams/$teamId',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedDashboardAgentsAgentIdIndexRoute =
  AuthenticatedDashboardAgentsAgentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardAgentsAgentIdRouteRoute,
  } as any)
const AuthenticatedDashboardAgentsAgentIdEditRoute =
  AuthenticatedDashboardAgentsAgentIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedDashboardAgentsAgentIdRouteRoute,
  } as any)
const AuthenticatedDashboardAgentsAgentIdScheduleRoute =
  AuthenticatedDashboardAgentsAgentIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => AuthenticatedDashboardAgentsAgentIdRouteRoute,
  } as any)
const AuthenticatedDashboardAgentsAgentIdTriggersRoute =
  AuthenticatedDashboardAgentsAgentIdTriggersRouteImport.update({
    id: '/triggers',
    path: '/triggers',
    getParentRoute: () => AuthenticatedDashboardAgentsAgentIdRouteRoute,
  } as any)
const AuthenticatedDashboardProjectsProjectIdIndexRoute =
  AuthenticatedDashboardProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedDashboardProjectsProjectIdAppsRoute =
  AuthenticatedDashboardProjectsProjectIdAppsRouteImport.update({
    id: '/apps',
    path: '/apps',
    getParentRoute: () => AuthenticatedDashboardProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedDashboardProjectsProjectIdArtifactsRoute =
  AuthenticatedDashboardProjectsProjectIdArtifactsRouteImport.update({
    id: '/artifacts',
    path: '/artifacts',
    getParentRoute: () => AuthenticatedDashboardProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedDashboardProjectsProjectIdChatsRoute =
  AuthenticatedDashboardProjectsProjectIdChatsRouteImport.update({
    id: '/chats',
    path: '/chats',
    getParentRoute: () => AuthenticatedDashboardProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedDashboardProjectsProjectIdDashboardsRoute =
  AuthenticatedDashboardProjectsProjectIdDashboardsRouteImport.update({
    id: '/dashboards',
    path: '/dashboards',
    getParentRoute: () => AuthenticatedDashboardProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedDashboardProjectsProjectIdFilesRoute =
  AuthenticatedDashboardProjectsProjectIdFilesRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => AuthenticatedDashboardProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedSettingsOrgMembersIndexRoute =
  AuthenticatedSettingsOrgMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedSettingsOrgMembersUserIdRouteRoute =
  AuthenticatedSettingsOrgMembersUserIdRouteRouteImport.update({
    id: '/members/$userId',
    path: '/members/$userId',
    getParentRoute: () => AuthenticatedSettingsOrgRouteRoute,
  } as any)
const AuthenticatedDashboardAgentsAgentIdRunsIndexRoute =
  AuthenticatedDashboardAgentsAgentIdRunsIndexRouteImport.update({
    id: '/runs/',
    path: '/runs/',
    getParentRoute: () => AuthenticatedDashboardAgentsAgentIdRouteRoute,
  } as any)
const AuthenticatedDashboardAgentsAgentIdRunsRunIdRoute =
  AuthenticatedDashboardAgentsAgentIdRunsRunIdRouteImport.update({
    id: '/runs/$runId',
    path: '/runs/$runId',
    getParentRoute: () => AuthenticatedDashboardAgentsAgentIdRouteRoute,
  } as any)
const AuthenticatedSettingsOrgMembersUserIdIndexRoute =
  AuthenticatedSettingsOrgMembersUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsOrgMembersUserIdRouteRoute,
  } as any)
const AuthenticatedSettingsOrgMembersUserIdAuditRoute =
  AuthenticatedSettingsOrgMembersUserIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthenticatedSettingsOrgMembersUserIdRouteRoute,
  } as any)
const AuthenticatedSettingsOrgMembersUserIdProjectsRoute =
  AuthenticatedSettingsOrgMembersUserIdProjectsRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => AuthenticatedSettingsOrgMembersUserIdRouteRoute,
  } as any)
const AuthenticatedSettingsOrgMembersUserIdSpacesRoute =
  AuthenticatedSettingsOrgMembersUserIdSpacesRouteImport.update({
    id: '/spaces',
    path: '/spaces',
    getParentRoute: () => AuthenticatedSettingsOrgMembersUserIdRouteRoute,
  } as any)
const AuthenticatedSettingsOrgMembersUserIdUsageRoute =
  AuthenticatedSettingsOrgMembersUserIdUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedSettingsOrgMembersUserIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/device': typeof DeviceRoute
  '/onboarding': typeof OnboardingRoute
  '/pricing': typeof PricingRoute
  '/suspended': typeof SuspendedRoute
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/home': typeof AuthenticatedHomeRoute
  '/whats-new': typeof AuthenticatedWhatsNewRoute
  '/auth/join': typeof AuthJoinRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/oauth': typeof AuthOauthRoute
  '/auth/recover': typeof AuthRecoverRoute
  '/auth/reset': typeof AuthResetRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/start-signup': typeof AuthStartSignupRoute
  '/open-artifact/$artifactId': typeof OpenArtifactArtifactIdRoute
  '/shared/$token': typeof SharedTokenRoute
  '/settings/org': typeof AuthenticatedSettingsOrgRouteRouteWithChildren
  '/dashboard/artifacts': typeof AuthenticatedDashboardArtifactsRoute
  '/dashboard/audit-logs': typeof AuthenticatedDashboardAuditLogsRoute
  '/dashboard/compliance': typeof AuthenticatedDashboardComplianceRoute
  '/dashboard/feedback': typeof AuthenticatedDashboardFeedbackRoute
  '/dashboard/integrations': typeof AuthenticatedDashboardIntegrationsRoute
  '/dashboard/members': typeof AuthenticatedDashboardMembersRoute
  '/dashboard/subscription': typeof AuthenticatedDashboardSubscriptionRoute
  '/profile/connections': typeof AuthenticatedProfileConnectionsRoute
  '/profile/preferences': typeof AuthenticatedProfilePreferencesRoute
  '/profile/presentation-templates': typeof AuthenticatedProfilePresentationTemplatesRoute
  '/profile/security': typeof AuthenticatedProfileSecurityRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute
  '/settings/compliance': typeof AuthenticatedSettingsComplianceRoute
  '/settings/connections': typeof AuthenticatedSettingsConnectionsRoute
  '/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
  '/settings/memory': typeof AuthenticatedSettingsMemoryRoute
  '/settings/preferences': typeof AuthenticatedSettingsPreferencesRoute
  '/settings/presentation-templates': typeof AuthenticatedSettingsPresentationTemplatesRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/profile/': typeof AuthenticatedProfileIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/dashboard/agents/$agentId': typeof AuthenticatedDashboardAgentsAgentIdRouteRouteWithChildren
  '/dashboard/projects/$projectId': typeof AuthenticatedDashboardProjectsProjectIdRouteRouteWithChildren
  '/dashboard/admin/agents': typeof AuthenticatedDashboardAdminAgentsRoute
  '/dashboard/admin/integrations': typeof AuthenticatedDashboardAdminIntegrationsRoute
  '/dashboard/admin/presentation-templates': typeof AuthenticatedDashboardAdminPresentationTemplatesRoute
  '/dashboard/admin/private-models': typeof AuthenticatedDashboardAdminPrivateModelsRoute
  '/dashboard/admin/rights': typeof AuthenticatedDashboardAdminRightsRoute
  '/dashboard/admin/scim': typeof AuthenticatedDashboardAdminScimRoute
  '/dashboard/admin/uno': typeof AuthenticatedDashboardAdminUnoRoute
  '/dashboard/agents/approvals': typeof AuthenticatedDashboardAgentsApprovalsRoute
  '/dashboard/agents/new': typeof AuthenticatedDashboardAgentsNewRoute
  '/dashboard/agents/templates': typeof AuthenticatedDashboardAgentsTemplatesRoute
  '/dashboard/chats/$chatId': typeof AuthenticatedDashboardChatsChatIdRoute
  '/dashboard/datasets/$spaceId': typeof AuthenticatedDashboardDatasetsSpaceIdRoute
  '/dashboard/spaces/$spaceId': typeof AuthenticatedDashboardSpacesSpaceIdRoute
  '/dashboard/teams/$teamId': typeof AuthenticatedDashboardTeamsTeamIdRoute
  '/settings/org/agent-policy': typeof AuthenticatedSettingsOrgAgentPolicyRoute
  '/settings/org/agents': typeof AuthenticatedSettingsOrgAgentsRoute
  '/settings/org/integrations': typeof AuthenticatedSettingsOrgIntegrationsRoute
  '/settings/org/models': typeof AuthenticatedSettingsOrgModelsRoute
  '/settings/org/overview': typeof AuthenticatedSettingsOrgOverviewRoute
  '/settings/org/presentation-templates': typeof AuthenticatedSettingsOrgPresentationTemplatesRoute
  '/settings/org/private-models': typeof AuthenticatedSettingsOrgPrivateModelsRoute
  '/settings/org/rights': typeof AuthenticatedSettingsOrgRightsRoute
  '/settings/org/scim': typeof AuthenticatedSettingsOrgScimRoute
  '/settings/org/subscription': typeof AuthenticatedSettingsOrgSubscriptionRoute
  '/settings/org/uno': typeof AuthenticatedSettingsOrgUnoRoute
  '/settings/personas/store': typeof AuthenticatedSettingsPersonasStoreRoute
  '/settings/teams/$teamId': typeof AuthenticatedSettingsTeamsTeamIdRoute
  '/dashboard/admin/': typeof AuthenticatedDashboardAdminIndexRoute
  '/dashboard/agents/': typeof AuthenticatedDashboardAgentsIndexRoute
  '/dashboard/chats/': typeof AuthenticatedDashboardChatsIndexRoute
  '/dashboard/datasets/': typeof AuthenticatedDashboardDatasetsIndexRoute
  '/dashboard/projects/': typeof AuthenticatedDashboardProjectsIndexRoute
  '/dashboard/spaces/': typeof AuthenticatedDashboardSpacesIndexRoute
  '/dashboard/teams/': typeof AuthenticatedDashboardTeamsIndexRoute
  '/settings/personas/': typeof AuthenticatedSettingsPersonasIndexRoute
  '/settings/teams/': typeof AuthenticatedSettingsTeamsIndexRoute
  '/settings/org/members/$userId': typeof AuthenticatedSettingsOrgMembersUserIdRouteRouteWithChildren
  '/dashboard/agents/$agentId/edit': typeof AuthenticatedDashboardAgentsAgentIdEditRoute
  '/dashboard/agents/$agentId/schedule': typeof AuthenticatedDashboardAgentsAgentIdScheduleRoute
  '/dashboard/agents/$agentId/triggers': typeof AuthenticatedDashboardAgentsAgentIdTriggersRoute
  '/dashboard/projects/$projectId/apps': typeof AuthenticatedDashboardProjectsProjectIdAppsRoute
  '/dashboard/projects/$projectId/artifacts': typeof AuthenticatedDashboardProjectsProjectIdArtifactsRoute
  '/dashboard/projects/$projectId/chats': typeof AuthenticatedDashboardProjectsProjectIdChatsRoute
  '/dashboard/projects/$projectId/dashboards': typeof AuthenticatedDashboardProjectsProjectIdDashboardsRoute
  '/dashboard/projects/$projectId/files': typeof AuthenticatedDashboardProjectsProjectIdFilesRoute
  '/dashboard/agents/$agentId/': typeof AuthenticatedDashboardAgentsAgentIdIndexRoute
  '/dashboard/projects/$projectId/': typeof AuthenticatedDashboardProjectsProjectIdIndexRoute
  '/settings/org/members/': typeof AuthenticatedSettingsOrgMembersIndexRoute
  '/dashboard/agents/$agentId/runs/$runId': typeof AuthenticatedDashboardAgentsAgentIdRunsRunIdRoute
  '/settings/org/members/$userId/audit': typeof AuthenticatedSettingsOrgMembersUserIdAuditRoute
  '/settings/org/members/$userId/projects': typeof AuthenticatedSettingsOrgMembersUserIdProjectsRoute
  '/settings/org/members/$userId/spaces': typeof AuthenticatedSettingsOrgMembersUserIdSpacesRoute
  '/settings/org/members/$userId/usage': typeof AuthenticatedSettingsOrgMembersUserIdUsageRoute
  '/dashboard/agents/$agentId/runs/': typeof AuthenticatedDashboardAgentsAgentIdRunsIndexRoute
  '/settings/org/members/$userId/': typeof AuthenticatedSettingsOrgMembersUserIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/device': typeof DeviceRoute
  '/onboarding': typeof OnboardingRoute
  '/pricing': typeof PricingRoute
  '/suspended': typeof SuspendedRoute
  '/home': typeof AuthenticatedHomeRoute
  '/whats-new': typeof AuthenticatedWhatsNewRoute
  '/auth/join': typeof AuthJoinRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/oauth': typeof AuthOauthRoute
  '/auth/recover': typeof AuthRecoverRoute
  '/auth/reset': typeof AuthResetRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/start-signup': typeof AuthStartSignupRoute
  '/open-artifact/$artifactId': typeof OpenArtifactArtifactIdRoute
  '/shared/$token': typeof SharedTokenRoute
  '/settings/org': typeof AuthenticatedSettingsOrgRouteRouteWithChildren
  '/dashboard/artifacts': typeof AuthenticatedDashboardArtifactsRoute
  '/dashboard/audit-logs': typeof AuthenticatedDashboardAuditLogsRoute
  '/dashboard/compliance': typeof AuthenticatedDashboardComplianceRoute
  '/dashboard/feedback': typeof AuthenticatedDashboardFeedbackRoute
  '/dashboard/integrations': typeof AuthenticatedDashboardIntegrationsRoute
  '/dashboard/members': typeof AuthenticatedDashboardMembersRoute
  '/dashboard/subscription': typeof AuthenticatedDashboardSubscriptionRoute
  '/profile/connections': typeof AuthenticatedProfileConnectionsRoute
  '/profile/preferences': typeof AuthenticatedProfilePreferencesRoute
  '/profile/presentation-templates': typeof AuthenticatedProfilePresentationTemplatesRoute
  '/profile/security': typeof AuthenticatedProfileSecurityRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute
  '/settings/compliance': typeof AuthenticatedSettingsComplianceRoute
  '/settings/connections': typeof AuthenticatedSettingsConnectionsRoute
  '/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
  '/settings/memory': typeof AuthenticatedSettingsMemoryRoute
  '/settings/preferences': typeof AuthenticatedSettingsPreferencesRoute
  '/settings/presentation-templates': typeof AuthenticatedSettingsPresentationTemplatesRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/dashboard/admin/agents': typeof AuthenticatedDashboardAdminAgentsRoute
  '/dashboard/admin/integrations': typeof AuthenticatedDashboardAdminIntegrationsRoute
  '/dashboard/admin/presentation-templates': typeof AuthenticatedDashboardAdminPresentationTemplatesRoute
  '/dashboard/admin/private-models': typeof AuthenticatedDashboardAdminPrivateModelsRoute
  '/dashboard/admin/rights': typeof AuthenticatedDashboardAdminRightsRoute
  '/dashboard/admin/scim': typeof AuthenticatedDashboardAdminScimRoute
  '/dashboard/admin/uno': typeof AuthenticatedDashboardAdminUnoRoute
  '/dashboard/agents/approvals': typeof AuthenticatedDashboardAgentsApprovalsRoute
  '/dashboard/agents/new': typeof AuthenticatedDashboardAgentsNewRoute
  '/dashboard/agents/templates': typeof AuthenticatedDashboardAgentsTemplatesRoute
  '/dashboard/chats/$chatId': typeof AuthenticatedDashboardChatsChatIdRoute
  '/dashboard/datasets/$spaceId': typeof AuthenticatedDashboardDatasetsSpaceIdRoute
  '/dashboard/spaces/$spaceId': typeof AuthenticatedDashboardSpacesSpaceIdRoute
  '/dashboard/teams/$teamId': typeof AuthenticatedDashboardTeamsTeamIdRoute
  '/settings/org/agent-policy': typeof AuthenticatedSettingsOrgAgentPolicyRoute
  '/settings/org/agents': typeof AuthenticatedSettingsOrgAgentsRoute
  '/settings/org/integrations': typeof AuthenticatedSettingsOrgIntegrationsRoute
  '/settings/org/models': typeof AuthenticatedSettingsOrgModelsRoute
  '/settings/org/overview': typeof AuthenticatedSettingsOrgOverviewRoute
  '/settings/org/presentation-templates': typeof AuthenticatedSettingsOrgPresentationTemplatesRoute
  '/settings/org/private-models': typeof AuthenticatedSettingsOrgPrivateModelsRoute
  '/settings/org/rights': typeof AuthenticatedSettingsOrgRightsRoute
  '/settings/org/scim': typeof AuthenticatedSettingsOrgScimRoute
  '/settings/org/subscription': typeof AuthenticatedSettingsOrgSubscriptionRoute
  '/settings/org/uno': typeof AuthenticatedSettingsOrgUnoRoute
  '/settings/personas/store': typeof AuthenticatedSettingsPersonasStoreRoute
  '/settings/teams/$teamId': typeof AuthenticatedSettingsTeamsTeamIdRoute
  '/dashboard/admin': typeof AuthenticatedDashboardAdminIndexRoute
  '/dashboard/agents': typeof AuthenticatedDashboardAgentsIndexRoute
  '/dashboard/chats': typeof AuthenticatedDashboardChatsIndexRoute
  '/dashboard/datasets': typeof AuthenticatedDashboardDatasetsIndexRoute
  '/dashboard/projects': typeof AuthenticatedDashboardProjectsIndexRoute
  '/dashboard/spaces': typeof AuthenticatedDashboardSpacesIndexRoute
  '/dashboard/teams': typeof AuthenticatedDashboardTeamsIndexRoute
  '/settings/personas': typeof AuthenticatedSettingsPersonasIndexRoute
  '/settings/teams': typeof AuthenticatedSettingsTeamsIndexRoute
  '/dashboard/agents/$agentId/edit': typeof AuthenticatedDashboardAgentsAgentIdEditRoute
  '/dashboard/agents/$agentId/schedule': typeof AuthenticatedDashboardAgentsAgentIdScheduleRoute
  '/dashboard/agents/$agentId/triggers': typeof AuthenticatedDashboardAgentsAgentIdTriggersRoute
  '/dashboard/projects/$projectId/apps': typeof AuthenticatedDashboardProjectsProjectIdAppsRoute
  '/dashboard/projects/$projectId/artifacts': typeof AuthenticatedDashboardProjectsProjectIdArtifactsRoute
  '/dashboard/projects/$projectId/chats': typeof AuthenticatedDashboardProjectsProjectIdChatsRoute
  '/dashboard/projects/$projectId/dashboards': typeof AuthenticatedDashboardProjectsProjectIdDashboardsRoute
  '/dashboard/projects/$projectId/files': typeof AuthenticatedDashboardProjectsProjectIdFilesRoute
  '/dashboard/agents/$agentId': typeof AuthenticatedDashboardAgentsAgentIdIndexRoute
  '/dashboard/projects/$projectId': typeof AuthenticatedDashboardProjectsProjectIdIndexRoute
  '/settings/org/members': typeof AuthenticatedSettingsOrgMembersIndexRoute
  '/dashboard/agents/$agentId/runs/$runId': typeof AuthenticatedDashboardAgentsAgentIdRunsRunIdRoute
  '/settings/org/members/$userId/audit': typeof AuthenticatedSettingsOrgMembersUserIdAuditRoute
  '/settings/org/members/$userId/projects': typeof AuthenticatedSettingsOrgMembersUserIdProjectsRoute
  '/settings/org/members/$userId/spaces': typeof AuthenticatedSettingsOrgMembersUserIdSpacesRoute
  '/settings/org/members/$userId/usage': typeof AuthenticatedSettingsOrgMembersUserIdUsageRoute
  '/dashboard/agents/$agentId/runs': typeof AuthenticatedDashboardAgentsAgentIdRunsIndexRoute
  '/settings/org/members/$userId': typeof AuthenticatedSettingsOrgMembersUserIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/device': typeof DeviceRoute
  '/onboarding': typeof OnboardingRoute
  '/pricing': typeof PricingRoute
  '/suspended': typeof SuspendedRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/whats-new': typeof AuthenticatedWhatsNewRoute
  '/auth/join': typeof AuthJoinRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/oauth': typeof AuthOauthRoute
  '/auth/recover': typeof AuthRecoverRoute
  '/auth/reset': typeof AuthResetRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/start-signup': typeof AuthStartSignupRoute
  '/open-artifact/$artifactId': typeof OpenArtifactArtifactIdRoute
  '/shared/$token': typeof SharedTokenRoute
  '/_authenticated/settings/org': typeof AuthenticatedSettingsOrgRouteRouteWithChildren
  '/_authenticated/dashboard/artifacts': typeof AuthenticatedDashboardArtifactsRoute
  '/_authenticated/dashboard/audit-logs': typeof AuthenticatedDashboardAuditLogsRoute
  '/_authenticated/dashboard/compliance': typeof AuthenticatedDashboardComplianceRoute
  '/_authenticated/dashboard/feedback': typeof AuthenticatedDashboardFeedbackRoute
  '/_authenticated/dashboard/integrations': typeof AuthenticatedDashboardIntegrationsRoute
  '/_authenticated/dashboard/members': typeof AuthenticatedDashboardMembersRoute
  '/_authenticated/dashboard/subscription': typeof AuthenticatedDashboardSubscriptionRoute
  '/_authenticated/profile/connections': typeof AuthenticatedProfileConnectionsRoute
  '/_authenticated/profile/preferences': typeof AuthenticatedProfilePreferencesRoute
  '/_authenticated/profile/presentation-templates': typeof AuthenticatedProfilePresentationTemplatesRoute
  '/_authenticated/profile/security': typeof AuthenticatedProfileSecurityRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute
  '/_authenticated/settings/compliance': typeof AuthenticatedSettingsComplianceRoute
  '/_authenticated/settings/connections': typeof AuthenticatedSettingsConnectionsRoute
  '/_authenticated/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
  '/_authenticated/settings/memory': typeof AuthenticatedSettingsMemoryRoute
  '/_authenticated/settings/preferences': typeof AuthenticatedSettingsPreferencesRoute
  '/_authenticated/settings/presentation-templates': typeof AuthenticatedSettingsPresentationTemplatesRoute
  '/_authenticated/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/dashboard/agents/$agentId': typeof AuthenticatedDashboardAgentsAgentIdRouteRouteWithChildren
  '/_authenticated/dashboard/projects/$projectId': typeof AuthenticatedDashboardProjectsProjectIdRouteRouteWithChildren
  '/_authenticated/dashboard/admin/agents': typeof AuthenticatedDashboardAdminAgentsRoute
  '/_authenticated/dashboard/admin/integrations': typeof AuthenticatedDashboardAdminIntegrationsRoute
  '/_authenticated/dashboard/admin/presentation-templates': typeof AuthenticatedDashboardAdminPresentationTemplatesRoute
  '/_authenticated/dashboard/admin/private-models': typeof AuthenticatedDashboardAdminPrivateModelsRoute
  '/_authenticated/dashboard/admin/rights': typeof AuthenticatedDashboardAdminRightsRoute
  '/_authenticated/dashboard/admin/scim': typeof AuthenticatedDashboardAdminScimRoute
  '/_authenticated/dashboard/admin/uno': typeof AuthenticatedDashboardAdminUnoRoute
  '/_authenticated/dashboard/agents/approvals': typeof AuthenticatedDashboardAgentsApprovalsRoute
  '/_authenticated/dashboard/agents/new': typeof AuthenticatedDashboardAgentsNewRoute
  '/_authenticated/dashboard/agents/templates': typeof AuthenticatedDashboardAgentsTemplatesRoute
  '/_authenticated/dashboard/chats/$chatId': typeof AuthenticatedDashboardChatsChatIdRoute
  '/_authenticated/dashboard/datasets/$spaceId': typeof AuthenticatedDashboardDatasetsSpaceIdRoute
  '/_authenticated/dashboard/spaces/$spaceId': typeof AuthenticatedDashboardSpacesSpaceIdRoute
  '/_authenticated/dashboard/teams/$teamId': typeof AuthenticatedDashboardTeamsTeamIdRoute
  '/_authenticated/settings/org/agent-policy': typeof AuthenticatedSettingsOrgAgentPolicyRoute
  '/_authenticated/settings/org/agents': typeof AuthenticatedSettingsOrgAgentsRoute
  '/_authenticated/settings/org/integrations': typeof AuthenticatedSettingsOrgIntegrationsRoute
  '/_authenticated/settings/org/models': typeof AuthenticatedSettingsOrgModelsRoute
  '/_authenticated/settings/org/overview': typeof AuthenticatedSettingsOrgOverviewRoute
  '/_authenticated/settings/org/presentation-templates': typeof AuthenticatedSettingsOrgPresentationTemplatesRoute
  '/_authenticated/settings/org/private-models': typeof AuthenticatedSettingsOrgPrivateModelsRoute
  '/_authenticated/settings/org/rights': typeof AuthenticatedSettingsOrgRightsRoute
  '/_authenticated/settings/org/scim': typeof AuthenticatedSettingsOrgScimRoute
  '/_authenticated/settings/org/subscription': typeof AuthenticatedSettingsOrgSubscriptionRoute
  '/_authenticated/settings/org/uno': typeof AuthenticatedSettingsOrgUnoRoute
  '/_authenticated/settings/personas/store': typeof AuthenticatedSettingsPersonasStoreRoute
  '/_authenticated/settings/teams/$teamId': typeof AuthenticatedSettingsTeamsTeamIdRoute
  '/_authenticated/dashboard/admin/': typeof AuthenticatedDashboardAdminIndexRoute
  '/_authenticated/dashboard/agents/': typeof AuthenticatedDashboardAgentsIndexRoute
  '/_authenticated/dashboard/chats/': typeof AuthenticatedDashboardChatsIndexRoute
  '/_authenticated/dashboard/datasets/': typeof AuthenticatedDashboardDatasetsIndexRoute
  '/_authenticated/dashboard/projects/': typeof AuthenticatedDashboardProjectsIndexRoute
  '/_authenticated/dashboard/spaces/': typeof AuthenticatedDashboardSpacesIndexRoute
  '/_authenticated/dashboard/teams/': typeof AuthenticatedDashboardTeamsIndexRoute
  '/_authenticated/settings/personas/': typeof AuthenticatedSettingsPersonasIndexRoute
  '/_authenticated/settings/teams/': typeof AuthenticatedSettingsTeamsIndexRoute
  '/_authenticated/settings/org/members/$userId': typeof AuthenticatedSettingsOrgMembersUserIdRouteRouteWithChildren
  '/_authenticated/dashboard/agents/$agentId/edit': typeof AuthenticatedDashboardAgentsAgentIdEditRoute
  '/_authenticated/dashboard/agents/$agentId/schedule': typeof AuthenticatedDashboardAgentsAgentIdScheduleRoute
  '/_authenticated/dashboard/agents/$agentId/triggers': typeof AuthenticatedDashboardAgentsAgentIdTriggersRoute
  '/_authenticated/dashboard/projects/$projectId/apps': typeof AuthenticatedDashboardProjectsProjectIdAppsRoute
  '/_authenticated/dashboard/projects/$projectId/artifacts': typeof AuthenticatedDashboardProjectsProjectIdArtifactsRoute
  '/_authenticated/dashboard/projects/$projectId/chats': typeof AuthenticatedDashboardProjectsProjectIdChatsRoute
  '/_authenticated/dashboard/projects/$projectId/dashboards': typeof AuthenticatedDashboardProjectsProjectIdDashboardsRoute
  '/_authenticated/dashboard/projects/$projectId/files': typeof AuthenticatedDashboardProjectsProjectIdFilesRoute
  '/_authenticated/dashboard/agents/$agentId/': typeof AuthenticatedDashboardAgentsAgentIdIndexRoute
  '/_authenticated/dashboard/projects/$projectId/': typeof AuthenticatedDashboardProjectsProjectIdIndexRoute
  '/_authenticated/settings/org/members/': typeof AuthenticatedSettingsOrgMembersIndexRoute
  '/_authenticated/dashboard/agents/$agentId/runs/$runId': typeof AuthenticatedDashboardAgentsAgentIdRunsRunIdRoute
  '/_authenticated/settings/org/members/$userId/audit': typeof AuthenticatedSettingsOrgMembersUserIdAuditRoute
  '/_authenticated/settings/org/members/$userId/projects': typeof AuthenticatedSettingsOrgMembersUserIdProjectsRoute
  '/_authenticated/settings/org/members/$userId/spaces': typeof AuthenticatedSettingsOrgMembersUserIdSpacesRoute
  '/_authenticated/settings/org/members/$userId/usage': typeof AuthenticatedSettingsOrgMembersUserIdUsageRoute
  '/_authenticated/dashboard/agents/$agentId/runs/': typeof AuthenticatedDashboardAgentsAgentIdRunsIndexRoute
  '/_authenticated/settings/org/members/$userId/': typeof AuthenticatedSettingsOrgMembersUserIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/device'
    | '/onboarding'
    | '/pricing'
    | '/suspended'
    | '/settings'
    | '/home'
    | '/whats-new'
    | '/auth/join'
    | '/auth/login'
    | '/auth/oauth'
    | '/auth/recover'
    | '/auth/reset'
    | '/auth/signup'
    | '/auth/start-signup'
    | '/open-artifact/$artifactId'
    | '/shared/$token'
    | '/settings/org'
    | '/dashboard/artifacts'
    | '/dashboard/audit-logs'
    | '/dashboard/compliance'
    | '/dashboard/feedback'
    | '/dashboard/integrations'
    | '/dashboard/members'
    | '/dashboard/subscription'
    | '/profile/connections'
    | '/profile/preferences'
    | '/profile/presentation-templates'
    | '/profile/security'
    | '/settings/account'
    | '/settings/audit-logs'
    | '/settings/compliance'
    | '/settings/connections'
    | '/settings/integrations'
    | '/settings/memory'
    | '/settings/preferences'
    | '/settings/presentation-templates'
    | '/settings/security'
    | '/dashboard/'
    | '/profile/'
    | '/settings/'
    | '/dashboard/agents/$agentId'
    | '/dashboard/projects/$projectId'
    | '/dashboard/admin/agents'
    | '/dashboard/admin/integrations'
    | '/dashboard/admin/presentation-templates'
    | '/dashboard/admin/private-models'
    | '/dashboard/admin/rights'
    | '/dashboard/admin/scim'
    | '/dashboard/admin/uno'
    | '/dashboard/agents/approvals'
    | '/dashboard/agents/new'
    | '/dashboard/agents/templates'
    | '/dashboard/chats/$chatId'
    | '/dashboard/datasets/$spaceId'
    | '/dashboard/spaces/$spaceId'
    | '/dashboard/teams/$teamId'
    | '/settings/org/agent-policy'
    | '/settings/org/agents'
    | '/settings/org/integrations'
    | '/settings/org/models'
    | '/settings/org/overview'
    | '/settings/org/presentation-templates'
    | '/settings/org/private-models'
    | '/settings/org/rights'
    | '/settings/org/scim'
    | '/settings/org/subscription'
    | '/settings/org/uno'
    | '/settings/personas/store'
    | '/settings/teams/$teamId'
    | '/dashboard/admin/'
    | '/dashboard/agents/'
    | '/dashboard/chats/'
    | '/dashboard/datasets/'
    | '/dashboard/projects/'
    | '/dashboard/spaces/'
    | '/dashboard/teams/'
    | '/settings/personas/'
    | '/settings/teams/'
    | '/settings/org/members/$userId'
    | '/dashboard/agents/$agentId/edit'
    | '/dashboard/agents/$agentId/schedule'
    | '/dashboard/agents/$agentId/triggers'
    | '/dashboard/projects/$projectId/apps'
    | '/dashboard/projects/$projectId/artifacts'
    | '/dashboard/projects/$projectId/chats'
    | '/dashboard/projects/$projectId/dashboards'
    | '/dashboard/projects/$projectId/files'
    | '/dashboard/agents/$agentId/'
    | '/dashboard/projects/$projectId/'
    | '/settings/org/members/'
    | '/dashboard/agents/$agentId/runs/$runId'
    | '/settings/org/members/$userId/audit'
    | '/settings/org/members/$userId/projects'
    | '/settings/org/members/$userId/spaces'
    | '/settings/org/members/$userId/usage'
    | '/dashboard/agents/$agentId/runs/'
    | '/settings/org/members/$userId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/device'
    | '/onboarding'
    | '/pricing'
    | '/suspended'
    | '/home'
    | '/whats-new'
    | '/auth/join'
    | '/auth/login'
    | '/auth/oauth'
    | '/auth/recover'
    | '/auth/reset'
    | '/auth/signup'
    | '/auth/start-signup'
    | '/open-artifact/$artifactId'
    | '/shared/$token'
    | '/settings/org'
    | '/dashboard/artifacts'
    | '/dashboard/audit-logs'
    | '/dashboard/compliance'
    | '/dashboard/feedback'
    | '/dashboard/integrations'
    | '/dashboard/members'
    | '/dashboard/subscription'
    | '/profile/connections'
    | '/profile/preferences'
    | '/profile/presentation-templates'
    | '/profile/security'
    | '/settings/account'
    | '/settings/audit-logs'
    | '/settings/compliance'
    | '/settings/connections'
    | '/settings/integrations'
    | '/settings/memory'
    | '/settings/preferences'
    | '/settings/presentation-templates'
    | '/settings/security'
    | '/dashboard'
    | '/profile'
    | '/settings'
    | '/dashboard/admin/agents'
    | '/dashboard/admin/integrations'
    | '/dashboard/admin/presentation-templates'
    | '/dashboard/admin/private-models'
    | '/dashboard/admin/rights'
    | '/dashboard/admin/scim'
    | '/dashboard/admin/uno'
    | '/dashboard/agents/approvals'
    | '/dashboard/agents/new'
    | '/dashboard/agents/templates'
    | '/dashboard/chats/$chatId'
    | '/dashboard/datasets/$spaceId'
    | '/dashboard/spaces/$spaceId'
    | '/dashboard/teams/$teamId'
    | '/settings/org/agent-policy'
    | '/settings/org/agents'
    | '/settings/org/integrations'
    | '/settings/org/models'
    | '/settings/org/overview'
    | '/settings/org/presentation-templates'
    | '/settings/org/private-models'
    | '/settings/org/rights'
    | '/settings/org/scim'
    | '/settings/org/subscription'
    | '/settings/org/uno'
    | '/settings/personas/store'
    | '/settings/teams/$teamId'
    | '/dashboard/admin'
    | '/dashboard/agents'
    | '/dashboard/chats'
    | '/dashboard/datasets'
    | '/dashboard/projects'
    | '/dashboard/spaces'
    | '/dashboard/teams'
    | '/settings/personas'
    | '/settings/teams'
    | '/dashboard/agents/$agentId/edit'
    | '/dashboard/agents/$agentId/schedule'
    | '/dashboard/agents/$agentId/triggers'
    | '/dashboard/projects/$projectId/apps'
    | '/dashboard/projects/$projectId/artifacts'
    | '/dashboard/projects/$projectId/chats'
    | '/dashboard/projects/$projectId/dashboards'
    | '/dashboard/projects/$projectId/files'
    | '/dashboard/agents/$agentId'
    | '/dashboard/projects/$projectId'
    | '/settings/org/members'
    | '/dashboard/agents/$agentId/runs/$runId'
    | '/settings/org/members/$userId/audit'
    | '/settings/org/members/$userId/projects'
    | '/settings/org/members/$userId/spaces'
    | '/settings/org/members/$userId/usage'
    | '/dashboard/agents/$agentId/runs'
    | '/settings/org/members/$userId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/auth'
    | '/device'
    | '/onboarding'
    | '/pricing'
    | '/suspended'
    | '/_authenticated/settings'
    | '/_authenticated/home'
    | '/_authenticated/whats-new'
    | '/auth/join'
    | '/auth/login'
    | '/auth/oauth'
    | '/auth/recover'
    | '/auth/reset'
    | '/auth/signup'
    | '/auth/start-signup'
    | '/open-artifact/$artifactId'
    | '/shared/$token'
    | '/_authenticated/settings/org'
    | '/_authenticated/dashboard/artifacts'
    | '/_authenticated/dashboard/audit-logs'
    | '/_authenticated/dashboard/compliance'
    | '/_authenticated/dashboard/feedback'
    | '/_authenticated/dashboard/integrations'
    | '/_authenticated/dashboard/members'
    | '/_authenticated/dashboard/subscription'
    | '/_authenticated/profile/connections'
    | '/_authenticated/profile/preferences'
    | '/_authenticated/profile/presentation-templates'
    | '/_authenticated/profile/security'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/audit-logs'
    | '/_authenticated/settings/compliance'
    | '/_authenticated/settings/connections'
    | '/_authenticated/settings/integrations'
    | '/_authenticated/settings/memory'
    | '/_authenticated/settings/preferences'
    | '/_authenticated/settings/presentation-templates'
    | '/_authenticated/settings/security'
    | '/_authenticated/dashboard/'
    | '/_authenticated/profile/'
    | '/_authenticated/settings/'
    | '/_authenticated/dashboard/agents/$agentId'
    | '/_authenticated/dashboard/projects/$projectId'
    | '/_authenticated/dashboard/admin/agents'
    | '/_authenticated/dashboard/admin/integrations'
    | '/_authenticated/dashboard/admin/presentation-templates'
    | '/_authenticated/dashboard/admin/private-models'
    | '/_authenticated/dashboard/admin/rights'
    | '/_authenticated/dashboard/admin/scim'
    | '/_authenticated/dashboard/admin/uno'
    | '/_authenticated/dashboard/agents/approvals'
    | '/_authenticated/dashboard/agents/new'
    | '/_authenticated/dashboard/agents/templates'
    | '/_authenticated/dashboard/chats/$chatId'
    | '/_authenticated/dashboard/datasets/$spaceId'
    | '/_authenticated/dashboard/spaces/$spaceId'
    | '/_authenticated/dashboard/teams/$teamId'
    | '/_authenticated/settings/org/agent-policy'
    | '/_authenticated/settings/org/agents'
    | '/_authenticated/settings/org/integrations'
    | '/_authenticated/settings/org/models'
    | '/_authenticated/settings/org/overview'
    | '/_authenticated/settings/org/presentation-templates'
    | '/_authenticated/settings/org/private-models'
    | '/_authenticated/settings/org/rights'
    | '/_authenticated/settings/org/scim'
    | '/_authenticated/settings/org/subscription'
    | '/_authenticated/settings/org/uno'
    | '/_authenticated/settings/personas/store'
    | '/_authenticated/settings/teams/$teamId'
    | '/_authenticated/dashboard/admin/'
    | '/_authenticated/dashboard/agents/'
    | '/_authenticated/dashboard/chats/'
    | '/_authenticated/dashboard/datasets/'
    | '/_authenticated/dashboard/projects/'
    | '/_authenticated/dashboard/spaces/'
    | '/_authenticated/dashboard/teams/'
    | '/_authenticated/settings/personas/'
    | '/_authenticated/settings/teams/'
    | '/_authenticated/settings/org/members/$userId'
    | '/_authenticated/dashboard/agents/$agentId/edit'
    | '/_authenticated/dashboard/agents/$agentId/schedule'
    | '/_authenticated/dashboard/agents/$agentId/triggers'
    | '/_authenticated/dashboard/projects/$projectId/apps'
    | '/_authenticated/dashboard/projects/$projectId/artifacts'
    | '/_authenticated/dashboard/projects/$projectId/chats'
    | '/_authenticated/dashboard/projects/$projectId/dashboards'
    | '/_authenticated/dashboard/projects/$projectId/files'
    | '/_authenticated/dashboard/agents/$agentId/'
    | '/_authenticated/dashboard/projects/$projectId/'
    | '/_authenticated/settings/org/members/'
    | '/_authenticated/dashboard/agents/$agentId/runs/$runId'
    | '/_authenticated/settings/org/members/$userId/audit'
    | '/_authenticated/settings/org/members/$userId/projects'
    | '/_authenticated/settings/org/members/$userId/spaces'
    | '/_authenticated/settings/org/members/$userId/usage'
    | '/_authenticated/dashboard/agents/$agentId/runs/'
    | '/_authenticated/settings/org/members/$userId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  DeviceRoute: typeof DeviceRoute
  OnboardingRoute: typeof OnboardingRoute
  PricingRoute: typeof PricingRoute
  SuspendedRoute: typeof SuspendedRoute
  OpenArtifactArtifactIdRoute: typeof OpenArtifactArtifactIdRoute
  SharedTokenRoute: typeof SharedTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device': {
      id: '/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof DeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suspended': {
      id: '/suspended'
      path: '/suspended'
      fullPath: '/suspended'
      preLoaderRoute: typeof SuspendedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/whats-new': {
      id: '/_authenticated/whats-new'
      path: '/whats-new'
      fullPath: '/whats-new'
      preLoaderRoute: typeof AuthenticatedWhatsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/auth/join': {
      id: '/auth/join'
      path: '/join'
      fullPath: '/auth/join'
      preLoaderRoute: typeof AuthJoinRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/oauth': {
      id: '/auth/oauth'
      path: '/oauth'
      fullPath: '/auth/oauth'
      preLoaderRoute: typeof AuthOauthRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/recover': {
      id: '/auth/recover'
      path: '/recover'
      fullPath: '/auth/recover'
      preLoaderRoute: typeof AuthRecoverRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/reset': {
      id: '/auth/reset'
      path: '/reset'
      fullPath: '/auth/reset'
      preLoaderRoute: typeof AuthResetRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/start-signup': {
      id: '/auth/start-signup'
      path: '/start-signup'
      fullPath: '/auth/start-signup'
      preLoaderRoute: typeof AuthStartSignupRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/open-artifact/$artifactId': {
      id: '/open-artifact/$artifactId'
      path: '/open-artifact/$artifactId'
      fullPath: '/open-artifact/$artifactId'
      preLoaderRoute: typeof OpenArtifactArtifactIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared/$token': {
      id: '/shared/$token'
      path: '/shared/$token'
      fullPath: '/shared/$token'
      preLoaderRoute: typeof SharedTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/artifacts': {
      id: '/_authenticated/dashboard/artifacts'
      path: '/dashboard/artifacts'
      fullPath: '/dashboard/artifacts'
      preLoaderRoute: typeof AuthenticatedDashboardArtifactsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/audit-logs': {
      id: '/_authenticated/dashboard/audit-logs'
      path: '/dashboard/audit-logs'
      fullPath: '/dashboard/audit-logs'
      preLoaderRoute: typeof AuthenticatedDashboardAuditLogsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/compliance': {
      id: '/_authenticated/dashboard/compliance'
      path: '/dashboard/compliance'
      fullPath: '/dashboard/compliance'
      preLoaderRoute: typeof AuthenticatedDashboardComplianceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/feedback': {
      id: '/_authenticated/dashboard/feedback'
      path: '/dashboard/feedback'
      fullPath: '/dashboard/feedback'
      preLoaderRoute: typeof AuthenticatedDashboardFeedbackRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/integrations': {
      id: '/_authenticated/dashboard/integrations'
      path: '/dashboard/integrations'
      fullPath: '/dashboard/integrations'
      preLoaderRoute: typeof AuthenticatedDashboardIntegrationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/members': {
      id: '/_authenticated/dashboard/members'
      path: '/dashboard/members'
      fullPath: '/dashboard/members'
      preLoaderRoute: typeof AuthenticatedDashboardMembersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/subscription': {
      id: '/_authenticated/dashboard/subscription'
      path: '/dashboard/subscription'
      fullPath: '/dashboard/subscription'
      preLoaderRoute: typeof AuthenticatedDashboardSubscriptionRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile/connections': {
      id: '/_authenticated/profile/connections'
      path: '/profile/connections'
      fullPath: '/profile/connections'
      preLoaderRoute: typeof AuthenticatedProfileConnectionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile/preferences': {
      id: '/_authenticated/profile/preferences'
      path: '/profile/preferences'
      fullPath: '/profile/preferences'
      preLoaderRoute: typeof AuthenticatedProfilePreferencesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile/presentation-templates': {
      id: '/_authenticated/profile/presentation-templates'
      path: '/profile/presentation-templates'
      fullPath: '/profile/presentation-templates'
      preLoaderRoute: typeof AuthenticatedProfilePresentationTemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile/security': {
      id: '/_authenticated/profile/security'
      path: '/profile/security'
      fullPath: '/profile/security'
      preLoaderRoute: typeof AuthenticatedProfileSecurityRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/audit-logs': {
      id: '/_authenticated/settings/audit-logs'
      path: '/audit-logs'
      fullPath: '/settings/audit-logs'
      preLoaderRoute: typeof AuthenticatedSettingsAuditLogsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/compliance': {
      id: '/_authenticated/settings/compliance'
      path: '/compliance'
      fullPath: '/settings/compliance'
      preLoaderRoute: typeof AuthenticatedSettingsComplianceRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/connections': {
      id: '/_authenticated/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof AuthenticatedSettingsConnectionsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/integrations': {
      id: '/_authenticated/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AuthenticatedSettingsIntegrationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/memory': {
      id: '/_authenticated/settings/memory'
      path: '/memory'
      fullPath: '/settings/memory'
      preLoaderRoute: typeof AuthenticatedSettingsMemoryRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/org': {
      id: '/_authenticated/settings/org'
      path: '/org'
      fullPath: '/settings/org'
      preLoaderRoute: typeof AuthenticatedSettingsOrgRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/preferences': {
      id: '/_authenticated/settings/preferences'
      path: '/preferences'
      fullPath: '/settings/preferences'
      preLoaderRoute: typeof AuthenticatedSettingsPreferencesRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/presentation-templates': {
      id: '/_authenticated/settings/presentation-templates'
      path: '/presentation-templates'
      fullPath: '/settings/presentation-templates'
      preLoaderRoute: typeof AuthenticatedSettingsPresentationTemplatesRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/security': {
      id: '/_authenticated/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/dashboard/admin/': {
      id: '/_authenticated/dashboard/admin/'
      path: '/dashboard/admin'
      fullPath: '/dashboard/admin/'
      preLoaderRoute: typeof AuthenticatedDashboardAdminIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/admin/agents': {
      id: '/_authenticated/dashboard/admin/agents'
      path: '/dashboard/admin/agents'
      fullPath: '/dashboard/admin/agents'
      preLoaderRoute: typeof AuthenticatedDashboardAdminAgentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/admin/integrations': {
      id: '/_authenticated/dashboard/admin/integrations'
      path: '/dashboard/admin/integrations'
      fullPath: '/dashboard/admin/integrations'
      preLoaderRoute: typeof AuthenticatedDashboardAdminIntegrationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/admin/presentation-templates': {
      id: '/_authenticated/dashboard/admin/presentation-templates'
      path: '/dashboard/admin/presentation-templates'
      fullPath: '/dashboard/admin/presentation-templates'
      preLoaderRoute: typeof AuthenticatedDashboardAdminPresentationTemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/admin/private-models': {
      id: '/_authenticated/dashboard/admin/private-models'
      path: '/dashboard/admin/private-models'
      fullPath: '/dashboard/admin/private-models'
      preLoaderRoute: typeof AuthenticatedDashboardAdminPrivateModelsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/admin/rights': {
      id: '/_authenticated/dashboard/admin/rights'
      path: '/dashboard/admin/rights'
      fullPath: '/dashboard/admin/rights'
      preLoaderRoute: typeof AuthenticatedDashboardAdminRightsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/admin/scim': {
      id: '/_authenticated/dashboard/admin/scim'
      path: '/dashboard/admin/scim'
      fullPath: '/dashboard/admin/scim'
      preLoaderRoute: typeof AuthenticatedDashboardAdminScimRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/admin/uno': {
      id: '/_authenticated/dashboard/admin/uno'
      path: '/dashboard/admin/uno'
      fullPath: '/dashboard/admin/uno'
      preLoaderRoute: typeof AuthenticatedDashboardAdminUnoRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/agents/': {
      id: '/_authenticated/dashboard/agents/'
      path: '/dashboard/agents'
      fullPath: '/dashboard/agents/'
      preLoaderRoute: typeof AuthenticatedDashboardAgentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/agents/$agentId': {
      id: '/_authenticated/dashboard/agents/$agentId'
      path: '/dashboard/agents/$agentId'
      fullPath: '/dashboard/agents/$agentId'
      preLoaderRoute: typeof AuthenticatedDashboardAgentsAgentIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/agents/approvals': {
      id: '/_authenticated/dashboard/agents/approvals'
      path: '/dashboard/agents/approvals'
      fullPath: '/dashboard/agents/approvals'
      preLoaderRoute: typeof AuthenticatedDashboardAgentsApprovalsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/agents/new': {
      id: '/_authenticated/dashboard/agents/new'
      path: '/dashboard/agents/new'
      fullPath: '/dashboard/agents/new'
      preLoaderRoute: typeof AuthenticatedDashboardAgentsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/agents/templates': {
      id: '/_authenticated/dashboard/agents/templates'
      path: '/dashboard/agents/templates'
      fullPath: '/dashboard/agents/templates'
      preLoaderRoute: typeof AuthenticatedDashboardAgentsTemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/chats/': {
      id: '/_authenticated/dashboard/chats/'
      path: '/dashboard/chats'
      fullPath: '/dashboard/chats/'
      preLoaderRoute: typeof AuthenticatedDashboardChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/chats/$chatId': {
      id: '/_authenticated/dashboard/chats/$chatId'
      path: '/dashboard/chats/$chatId'
      fullPath: '/dashboard/chats/$chatId'
      preLoaderRoute: typeof AuthenticatedDashboardChatsChatIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/datasets/': {
      id: '/_authenticated/dashboard/datasets/'
      path: '/dashboard/datasets'
      fullPath: '/dashboard/datasets/'
      preLoaderRoute: typeof AuthenticatedDashboardDatasetsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/datasets/$spaceId': {
      id: '/_authenticated/dashboard/datasets/$spaceId'
      path: '/dashboard/datasets/$spaceId'
      fullPath: '/dashboard/datasets/$spaceId'
      preLoaderRoute: typeof AuthenticatedDashboardDatasetsSpaceIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/projects/': {
      id: '/_authenticated/dashboard/projects/'
      path: '/dashboard/projects'
      fullPath: '/dashboard/projects/'
      preLoaderRoute: typeof AuthenticatedDashboardProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/projects/$projectId': {
      id: '/_authenticated/dashboard/projects/$projectId'
      path: '/dashboard/projects/$projectId'
      fullPath: '/dashboard/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedDashboardProjectsProjectIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/spaces/': {
      id: '/_authenticated/dashboard/spaces/'
      path: '/dashboard/spaces'
      fullPath: '/dashboard/spaces/'
      preLoaderRoute: typeof AuthenticatedDashboardSpacesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/spaces/$spaceId': {
      id: '/_authenticated/dashboard/spaces/$spaceId'
      path: '/dashboard/spaces/$spaceId'
      fullPath: '/dashboard/spaces/$spaceId'
      preLoaderRoute: typeof AuthenticatedDashboardSpacesSpaceIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/teams/': {
      id: '/_authenticated/dashboard/teams/'
      path: '/dashboard/teams'
      fullPath: '/dashboard/teams/'
      preLoaderRoute: typeof AuthenticatedDashboardTeamsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/teams/$teamId': {
      id: '/_authenticated/dashboard/teams/$teamId'
      path: '/dashboard/teams/$teamId'
      fullPath: '/dashboard/teams/$teamId'
      preLoaderRoute: typeof AuthenticatedDashboardTeamsTeamIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/org/agent-policy': {
      id: '/_authenticated/settings/org/agent-policy'
      path: '/agent-policy'
      fullPath: '/settings/org/agent-policy'
      preLoaderRoute: typeof AuthenticatedSettingsOrgAgentPolicyRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/settings/org/agents': {
      id: '/_authenticated/settings/org/agents'
      path: '/agents'
      fullPath: '/settings/org/agents'
      preLoaderRoute: typeof AuthenticatedSettingsOrgAgentsRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/settings/org/integrations': {
      id: '/_authenticated/settings/org/integrations'
      path: '/integrations'
      fullPath: '/settings/org/integrations'
      preLoaderRoute: typeof AuthenticatedSettingsOrgIntegrationsRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/settings/org/models': {
      id: '/_authenticated/settings/org/models'
      path: '/models'
      fullPath: '/settings/org/models'
      preLoaderRoute: typeof AuthenticatedSettingsOrgModelsRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/settings/org/overview': {
      id: '/_authenticated/settings/org/overview'
      path: '/overview'
      fullPath: '/settings/org/overview'
      preLoaderRoute: typeof AuthenticatedSettingsOrgOverviewRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/settings/org/presentation-templates': {
      id: '/_authenticated/settings/org/presentation-templates'
      path: '/presentation-templates'
      fullPath: '/settings/org/presentation-templates'
      preLoaderRoute: typeof AuthenticatedSettingsOrgPresentationTemplatesRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/settings/org/private-models': {
      id: '/_authenticated/settings/org/private-models'
      path: '/private-models'
      fullPath: '/settings/org/private-models'
      preLoaderRoute: typeof AuthenticatedSettingsOrgPrivateModelsRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/settings/org/rights': {
      id: '/_authenticated/settings/org/rights'
      path: '/rights'
      fullPath: '/settings/org/rights'
      preLoaderRoute: typeof AuthenticatedSettingsOrgRightsRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/settings/org/scim': {
      id: '/_authenticated/settings/org/scim'
      path: '/scim'
      fullPath: '/settings/org/scim'
      preLoaderRoute: typeof AuthenticatedSettingsOrgScimRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/settings/org/subscription': {
      id: '/_authenticated/settings/org/subscription'
      path: '/subscription'
      fullPath: '/settings/org/subscription'
      preLoaderRoute: typeof AuthenticatedSettingsOrgSubscriptionRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/settings/org/uno': {
      id: '/_authenticated/settings/org/uno'
      path: '/uno'
      fullPath: '/settings/org/uno'
      preLoaderRoute: typeof AuthenticatedSettingsOrgUnoRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/settings/personas/': {
      id: '/_authenticated/settings/personas/'
      path: '/personas'
      fullPath: '/settings/personas/'
      preLoaderRoute: typeof AuthenticatedSettingsPersonasIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/personas/store': {
      id: '/_authenticated/settings/personas/store'
      path: '/personas/store'
      fullPath: '/settings/personas/store'
      preLoaderRoute: typeof AuthenticatedSettingsPersonasStoreRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/teams/': {
      id: '/_authenticated/settings/teams/'
      path: '/teams'
      fullPath: '/settings/teams/'
      preLoaderRoute: typeof AuthenticatedSettingsTeamsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/teams/$teamId': {
      id: '/_authenticated/settings/teams/$teamId'
      path: '/teams/$teamId'
      fullPath: '/settings/teams/$teamId'
      preLoaderRoute: typeof AuthenticatedSettingsTeamsTeamIdRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/dashboard/agents/$agentId/': {
      id: '/_authenticated/dashboard/agents/$agentId/'
      path: '/'
      fullPath: '/dashboard/agents/$agentId/'
      preLoaderRoute: typeof AuthenticatedDashboardAgentsAgentIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardAgentsAgentIdRouteRoute
    }
    '/_authenticated/dashboard/agents/$agentId/edit': {
      id: '/_authenticated/dashboard/agents/$agentId/edit'
      path: '/edit'
      fullPath: '/dashboard/agents/$agentId/edit'
      preLoaderRoute: typeof AuthenticatedDashboardAgentsAgentIdEditRouteImport
      parentRoute: typeof AuthenticatedDashboardAgentsAgentIdRouteRoute
    }
    '/_authenticated/dashboard/agents/$agentId/schedule': {
      id: '/_authenticated/dashboard/agents/$agentId/schedule'
      path: '/schedule'
      fullPath: '/dashboard/agents/$agentId/schedule'
      preLoaderRoute: typeof AuthenticatedDashboardAgentsAgentIdScheduleRouteImport
      parentRoute: typeof AuthenticatedDashboardAgentsAgentIdRouteRoute
    }
    '/_authenticated/dashboard/agents/$agentId/triggers': {
      id: '/_authenticated/dashboard/agents/$agentId/triggers'
      path: '/triggers'
      fullPath: '/dashboard/agents/$agentId/triggers'
      preLoaderRoute: typeof AuthenticatedDashboardAgentsAgentIdTriggersRouteImport
      parentRoute: typeof AuthenticatedDashboardAgentsAgentIdRouteRoute
    }
    '/_authenticated/dashboard/projects/$projectId/': {
      id: '/_authenticated/dashboard/projects/$projectId/'
      path: '/'
      fullPath: '/dashboard/projects/$projectId/'
      preLoaderRoute: typeof AuthenticatedDashboardProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardProjectsProjectIdRouteRoute
    }
    '/_authenticated/dashboard/projects/$projectId/apps': {
      id: '/_authenticated/dashboard/projects/$projectId/apps'
      path: '/apps'
      fullPath: '/dashboard/projects/$projectId/apps'
      preLoaderRoute: typeof AuthenticatedDashboardProjectsProjectIdAppsRouteImport
      parentRoute: typeof AuthenticatedDashboardProjectsProjectIdRouteRoute
    }
    '/_authenticated/dashboard/projects/$projectId/artifacts': {
      id: '/_authenticated/dashboard/projects/$projectId/artifacts'
      path: '/artifacts'
      fullPath: '/dashboard/projects/$projectId/artifacts'
      preLoaderRoute: typeof AuthenticatedDashboardProjectsProjectIdArtifactsRouteImport
      parentRoute: typeof AuthenticatedDashboardProjectsProjectIdRouteRoute
    }
    '/_authenticated/dashboard/projects/$projectId/chats': {
      id: '/_authenticated/dashboard/projects/$projectId/chats'
      path: '/chats'
      fullPath: '/dashboard/projects/$projectId/chats'
      preLoaderRoute: typeof AuthenticatedDashboardProjectsProjectIdChatsRouteImport
      parentRoute: typeof AuthenticatedDashboardProjectsProjectIdRouteRoute
    }
    '/_authenticated/dashboard/projects/$projectId/dashboards': {
      id: '/_authenticated/dashboard/projects/$projectId/dashboards'
      path: '/dashboards'
      fullPath: '/dashboard/projects/$projectId/dashboards'
      preLoaderRoute: typeof AuthenticatedDashboardProjectsProjectIdDashboardsRouteImport
      parentRoute: typeof AuthenticatedDashboardProjectsProjectIdRouteRoute
    }
    '/_authenticated/dashboard/projects/$projectId/files': {
      id: '/_authenticated/dashboard/projects/$projectId/files'
      path: '/files'
      fullPath: '/dashboard/projects/$projectId/files'
      preLoaderRoute: typeof AuthenticatedDashboardProjectsProjectIdFilesRouteImport
      parentRoute: typeof AuthenticatedDashboardProjectsProjectIdRouteRoute
    }
    '/_authenticated/settings/org/members/': {
      id: '/_authenticated/settings/org/members/'
      path: '/members'
      fullPath: '/settings/org/members/'
      preLoaderRoute: typeof AuthenticatedSettingsOrgMembersIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/settings/org/members/$userId': {
      id: '/_authenticated/settings/org/members/$userId'
      path: '/members/$userId'
      fullPath: '/settings/org/members/$userId'
      preLoaderRoute: typeof AuthenticatedSettingsOrgMembersUserIdRouteRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgRouteRoute
    }
    '/_authenticated/dashboard/agents/$agentId/runs/': {
      id: '/_authenticated/dashboard/agents/$agentId/runs/'
      path: '/runs'
      fullPath: '/dashboard/agents/$agentId/runs/'
      preLoaderRoute: typeof AuthenticatedDashboardAgentsAgentIdRunsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardAgentsAgentIdRouteRoute
    }
    '/_authenticated/dashboard/agents/$agentId/runs/$runId': {
      id: '/_authenticated/dashboard/agents/$agentId/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/dashboard/agents/$agentId/runs/$runId'
      preLoaderRoute: typeof AuthenticatedDashboardAgentsAgentIdRunsRunIdRouteImport
      parentRoute: typeof AuthenticatedDashboardAgentsAgentIdRouteRoute
    }
    '/_authenticated/settings/org/members/$userId/': {
      id: '/_authenticated/settings/org/members/$userId/'
      path: '/'
      fullPath: '/settings/org/members/$userId/'
      preLoaderRoute: typeof AuthenticatedSettingsOrgMembersUserIdIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgMembersUserIdRouteRoute
    }
    '/_authenticated/settings/org/members/$userId/audit': {
      id: '/_authenticated/settings/org/members/$userId/audit'
      path: '/audit'
      fullPath: '/settings/org/members/$userId/audit'
      preLoaderRoute: typeof AuthenticatedSettingsOrgMembersUserIdAuditRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgMembersUserIdRouteRoute
    }
    '/_authenticated/settings/org/members/$userId/projects': {
      id: '/_authenticated/settings/org/members/$userId/projects'
      path: '/projects'
      fullPath: '/settings/org/members/$userId/projects'
      preLoaderRoute: typeof AuthenticatedSettingsOrgMembersUserIdProjectsRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgMembersUserIdRouteRoute
    }
    '/_authenticated/settings/org/members/$userId/spaces': {
      id: '/_authenticated/settings/org/members/$userId/spaces'
      path: '/spaces'
      fullPath: '/settings/org/members/$userId/spaces'
      preLoaderRoute: typeof AuthenticatedSettingsOrgMembersUserIdSpacesRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgMembersUserIdRouteRoute
    }
    '/_authenticated/settings/org/members/$userId/usage': {
      id: '/_authenticated/settings/org/members/$userId/usage'
      path: '/usage'
      fullPath: '/settings/org/members/$userId/usage'
      preLoaderRoute: typeof AuthenticatedSettingsOrgMembersUserIdUsageRouteImport
      parentRoute: typeof AuthenticatedSettingsOrgMembersUserIdRouteRoute
    }
  }
}

interface AuthenticatedSettingsOrgMembersUserIdRouteRouteChildren {
  AuthenticatedSettingsOrgMembersUserIdAuditRoute: typeof AuthenticatedSettingsOrgMembersUserIdAuditRoute
  AuthenticatedSettingsOrgMembersUserIdProjectsRoute: typeof AuthenticatedSettingsOrgMembersUserIdProjectsRoute
  AuthenticatedSettingsOrgMembersUserIdSpacesRoute: typeof AuthenticatedSettingsOrgMembersUserIdSpacesRoute
  AuthenticatedSettingsOrgMembersUserIdUsageRoute: typeof AuthenticatedSettingsOrgMembersUserIdUsageRoute
  AuthenticatedSettingsOrgMembersUserIdIndexRoute: typeof AuthenticatedSettingsOrgMembersUserIdIndexRoute
}

const AuthenticatedSettingsOrgMembersUserIdRouteRouteChildren: AuthenticatedSettingsOrgMembersUserIdRouteRouteChildren =
  {
    AuthenticatedSettingsOrgMembersUserIdAuditRoute:
      AuthenticatedSettingsOrgMembersUserIdAuditRoute,
    AuthenticatedSettingsOrgMembersUserIdProjectsRoute:
      AuthenticatedSettingsOrgMembersUserIdProjectsRoute,
    AuthenticatedSettingsOrgMembersUserIdSpacesRoute:
      AuthenticatedSettingsOrgMembersUserIdSpacesRoute,
    AuthenticatedSettingsOrgMembersUserIdUsageRoute:
      AuthenticatedSettingsOrgMembersUserIdUsageRoute,
    AuthenticatedSettingsOrgMembersUserIdIndexRoute:
      AuthenticatedSettingsOrgMembersUserIdIndexRoute,
  }

const AuthenticatedSettingsOrgMembersUserIdRouteRouteWithChildren =
  AuthenticatedSettingsOrgMembersUserIdRouteRoute._addFileChildren(
    AuthenticatedSettingsOrgMembersUserIdRouteRouteChildren,
  )

interface AuthenticatedSettingsOrgRouteRouteChildren {
  AuthenticatedSettingsOrgAgentPolicyRoute: typeof AuthenticatedSettingsOrgAgentPolicyRoute
  AuthenticatedSettingsOrgAgentsRoute: typeof AuthenticatedSettingsOrgAgentsRoute
  AuthenticatedSettingsOrgIntegrationsRoute: typeof AuthenticatedSettingsOrgIntegrationsRoute
  AuthenticatedSettingsOrgModelsRoute: typeof AuthenticatedSettingsOrgModelsRoute
  AuthenticatedSettingsOrgOverviewRoute: typeof AuthenticatedSettingsOrgOverviewRoute
  AuthenticatedSettingsOrgPresentationTemplatesRoute: typeof AuthenticatedSettingsOrgPresentationTemplatesRoute
  AuthenticatedSettingsOrgPrivateModelsRoute: typeof AuthenticatedSettingsOrgPrivateModelsRoute
  AuthenticatedSettingsOrgRightsRoute: typeof AuthenticatedSettingsOrgRightsRoute
  AuthenticatedSettingsOrgScimRoute: typeof AuthenticatedSettingsOrgScimRoute
  AuthenticatedSettingsOrgSubscriptionRoute: typeof AuthenticatedSettingsOrgSubscriptionRoute
  AuthenticatedSettingsOrgUnoRoute: typeof AuthenticatedSettingsOrgUnoRoute
  AuthenticatedSettingsOrgMembersUserIdRouteRoute: typeof AuthenticatedSettingsOrgMembersUserIdRouteRouteWithChildren
  AuthenticatedSettingsOrgMembersIndexRoute: typeof AuthenticatedSettingsOrgMembersIndexRoute
}

const AuthenticatedSettingsOrgRouteRouteChildren: AuthenticatedSettingsOrgRouteRouteChildren =
  {
    AuthenticatedSettingsOrgAgentPolicyRoute:
      AuthenticatedSettingsOrgAgentPolicyRoute,
    AuthenticatedSettingsOrgAgentsRoute: AuthenticatedSettingsOrgAgentsRoute,
    AuthenticatedSettingsOrgIntegrationsRoute:
      AuthenticatedSettingsOrgIntegrationsRoute,
    AuthenticatedSettingsOrgModelsRoute: AuthenticatedSettingsOrgModelsRoute,
    AuthenticatedSettingsOrgOverviewRoute:
      AuthenticatedSettingsOrgOverviewRoute,
    AuthenticatedSettingsOrgPresentationTemplatesRoute:
      AuthenticatedSettingsOrgPresentationTemplatesRoute,
    AuthenticatedSettingsOrgPrivateModelsRoute:
      AuthenticatedSettingsOrgPrivateModelsRoute,
    AuthenticatedSettingsOrgRightsRoute: AuthenticatedSettingsOrgRightsRoute,
    AuthenticatedSettingsOrgScimRoute: AuthenticatedSettingsOrgScimRoute,
    AuthenticatedSettingsOrgSubscriptionRoute:
      AuthenticatedSettingsOrgSubscriptionRoute,
    AuthenticatedSettingsOrgUnoRoute: AuthenticatedSettingsOrgUnoRoute,
    AuthenticatedSettingsOrgMembersUserIdRouteRoute:
      AuthenticatedSettingsOrgMembersUserIdRouteRouteWithChildren,
    AuthenticatedSettingsOrgMembersIndexRoute:
      AuthenticatedSettingsOrgMembersIndexRoute,
  }

const AuthenticatedSettingsOrgRouteRouteWithChildren =
  AuthenticatedSettingsOrgRouteRoute._addFileChildren(
    AuthenticatedSettingsOrgRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsOrgRouteRoute: typeof AuthenticatedSettingsOrgRouteRouteWithChildren
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAuditLogsRoute: typeof AuthenticatedSettingsAuditLogsRoute
  AuthenticatedSettingsComplianceRoute: typeof AuthenticatedSettingsComplianceRoute
  AuthenticatedSettingsConnectionsRoute: typeof AuthenticatedSettingsConnectionsRoute
  AuthenticatedSettingsIntegrationsRoute: typeof AuthenticatedSettingsIntegrationsRoute
  AuthenticatedSettingsMemoryRoute: typeof AuthenticatedSettingsMemoryRoute
  AuthenticatedSettingsPreferencesRoute: typeof AuthenticatedSettingsPreferencesRoute
  AuthenticatedSettingsPresentationTemplatesRoute: typeof AuthenticatedSettingsPresentationTemplatesRoute
  AuthenticatedSettingsSecurityRoute: typeof AuthenticatedSettingsSecurityRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSettingsPersonasStoreRoute: typeof AuthenticatedSettingsPersonasStoreRoute
  AuthenticatedSettingsTeamsTeamIdRoute: typeof AuthenticatedSettingsTeamsTeamIdRoute
  AuthenticatedSettingsPersonasIndexRoute: typeof AuthenticatedSettingsPersonasIndexRoute
  AuthenticatedSettingsTeamsIndexRoute: typeof AuthenticatedSettingsTeamsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsOrgRouteRoute:
      AuthenticatedSettingsOrgRouteRouteWithChildren,
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAuditLogsRoute: AuthenticatedSettingsAuditLogsRoute,
    AuthenticatedSettingsComplianceRoute: AuthenticatedSettingsComplianceRoute,
    AuthenticatedSettingsConnectionsRoute:
      AuthenticatedSettingsConnectionsRoute,
    AuthenticatedSettingsIntegrationsRoute:
      AuthenticatedSettingsIntegrationsRoute,
    AuthenticatedSettingsMemoryRoute: AuthenticatedSettingsMemoryRoute,
    AuthenticatedSettingsPreferencesRoute:
      AuthenticatedSettingsPreferencesRoute,
    AuthenticatedSettingsPresentationTemplatesRoute:
      AuthenticatedSettingsPresentationTemplatesRoute,
    AuthenticatedSettingsSecurityRoute: AuthenticatedSettingsSecurityRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
    AuthenticatedSettingsPersonasStoreRoute:
      AuthenticatedSettingsPersonasStoreRoute,
    AuthenticatedSettingsTeamsTeamIdRoute:
      AuthenticatedSettingsTeamsTeamIdRoute,
    AuthenticatedSettingsPersonasIndexRoute:
      AuthenticatedSettingsPersonasIndexRoute,
    AuthenticatedSettingsTeamsIndexRoute: AuthenticatedSettingsTeamsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedDashboardAgentsAgentIdRouteRouteChildren {
  AuthenticatedDashboardAgentsAgentIdEditRoute: typeof AuthenticatedDashboardAgentsAgentIdEditRoute
  AuthenticatedDashboardAgentsAgentIdScheduleRoute: typeof AuthenticatedDashboardAgentsAgentIdScheduleRoute
  AuthenticatedDashboardAgentsAgentIdTriggersRoute: typeof AuthenticatedDashboardAgentsAgentIdTriggersRoute
  AuthenticatedDashboardAgentsAgentIdIndexRoute: typeof AuthenticatedDashboardAgentsAgentIdIndexRoute
  AuthenticatedDashboardAgentsAgentIdRunsRunIdRoute: typeof AuthenticatedDashboardAgentsAgentIdRunsRunIdRoute
  AuthenticatedDashboardAgentsAgentIdRunsIndexRoute: typeof AuthenticatedDashboardAgentsAgentIdRunsIndexRoute
}

const AuthenticatedDashboardAgentsAgentIdRouteRouteChildren: AuthenticatedDashboardAgentsAgentIdRouteRouteChildren =
  {
    AuthenticatedDashboardAgentsAgentIdEditRoute:
      AuthenticatedDashboardAgentsAgentIdEditRoute,
    AuthenticatedDashboardAgentsAgentIdScheduleRoute:
      AuthenticatedDashboardAgentsAgentIdScheduleRoute,
    AuthenticatedDashboardAgentsAgentIdTriggersRoute:
      AuthenticatedDashboardAgentsAgentIdTriggersRoute,
    AuthenticatedDashboardAgentsAgentIdIndexRoute:
      AuthenticatedDashboardAgentsAgentIdIndexRoute,
    AuthenticatedDashboardAgentsAgentIdRunsRunIdRoute:
      AuthenticatedDashboardAgentsAgentIdRunsRunIdRoute,
    AuthenticatedDashboardAgentsAgentIdRunsIndexRoute:
      AuthenticatedDashboardAgentsAgentIdRunsIndexRoute,
  }

const AuthenticatedDashboardAgentsAgentIdRouteRouteWithChildren =
  AuthenticatedDashboardAgentsAgentIdRouteRoute._addFileChildren(
    AuthenticatedDashboardAgentsAgentIdRouteRouteChildren,
  )

interface AuthenticatedDashboardProjectsProjectIdRouteRouteChildren {
  AuthenticatedDashboardProjectsProjectIdAppsRoute: typeof AuthenticatedDashboardProjectsProjectIdAppsRoute
  AuthenticatedDashboardProjectsProjectIdArtifactsRoute: typeof AuthenticatedDashboardProjectsProjectIdArtifactsRoute
  AuthenticatedDashboardProjectsProjectIdChatsRoute: typeof AuthenticatedDashboardProjectsProjectIdChatsRoute
  AuthenticatedDashboardProjectsProjectIdDashboardsRoute: typeof AuthenticatedDashboardProjectsProjectIdDashboardsRoute
  AuthenticatedDashboardProjectsProjectIdFilesRoute: typeof AuthenticatedDashboardProjectsProjectIdFilesRoute
  AuthenticatedDashboardProjectsProjectIdIndexRoute: typeof AuthenticatedDashboardProjectsProjectIdIndexRoute
}

const AuthenticatedDashboardProjectsProjectIdRouteRouteChildren: AuthenticatedDashboardProjectsProjectIdRouteRouteChildren =
  {
    AuthenticatedDashboardProjectsProjectIdAppsRoute:
      AuthenticatedDashboardProjectsProjectIdAppsRoute,
    AuthenticatedDashboardProjectsProjectIdArtifactsRoute:
      AuthenticatedDashboardProjectsProjectIdArtifactsRoute,
    AuthenticatedDashboardProjectsProjectIdChatsRoute:
      AuthenticatedDashboardProjectsProjectIdChatsRoute,
    AuthenticatedDashboardProjectsProjectIdDashboardsRoute:
      AuthenticatedDashboardProjectsProjectIdDashboardsRoute,
    AuthenticatedDashboardProjectsProjectIdFilesRoute:
      AuthenticatedDashboardProjectsProjectIdFilesRoute,
    AuthenticatedDashboardProjectsProjectIdIndexRoute:
      AuthenticatedDashboardProjectsProjectIdIndexRoute,
  }

const AuthenticatedDashboardProjectsProjectIdRouteRouteWithChildren =
  AuthenticatedDashboardProjectsProjectIdRouteRoute._addFileChildren(
    AuthenticatedDashboardProjectsProjectIdRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedWhatsNewRoute: typeof AuthenticatedWhatsNewRoute
  AuthenticatedDashboardArtifactsRoute: typeof AuthenticatedDashboardArtifactsRoute
  AuthenticatedDashboardAuditLogsRoute: typeof AuthenticatedDashboardAuditLogsRoute
  AuthenticatedDashboardComplianceRoute: typeof AuthenticatedDashboardComplianceRoute
  AuthenticatedDashboardFeedbackRoute: typeof AuthenticatedDashboardFeedbackRoute
  AuthenticatedDashboardIntegrationsRoute: typeof AuthenticatedDashboardIntegrationsRoute
  AuthenticatedDashboardMembersRoute: typeof AuthenticatedDashboardMembersRoute
  AuthenticatedDashboardSubscriptionRoute: typeof AuthenticatedDashboardSubscriptionRoute
  AuthenticatedProfileConnectionsRoute: typeof AuthenticatedProfileConnectionsRoute
  AuthenticatedProfilePreferencesRoute: typeof AuthenticatedProfilePreferencesRoute
  AuthenticatedProfilePresentationTemplatesRoute: typeof AuthenticatedProfilePresentationTemplatesRoute
  AuthenticatedProfileSecurityRoute: typeof AuthenticatedProfileSecurityRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
  AuthenticatedDashboardAgentsAgentIdRouteRoute: typeof AuthenticatedDashboardAgentsAgentIdRouteRouteWithChildren
  AuthenticatedDashboardProjectsProjectIdRouteRoute: typeof AuthenticatedDashboardProjectsProjectIdRouteRouteWithChildren
  AuthenticatedDashboardAdminAgentsRoute: typeof AuthenticatedDashboardAdminAgentsRoute
  AuthenticatedDashboardAdminIntegrationsRoute: typeof AuthenticatedDashboardAdminIntegrationsRoute
  AuthenticatedDashboardAdminPresentationTemplatesRoute: typeof AuthenticatedDashboardAdminPresentationTemplatesRoute
  AuthenticatedDashboardAdminPrivateModelsRoute: typeof AuthenticatedDashboardAdminPrivateModelsRoute
  AuthenticatedDashboardAdminRightsRoute: typeof AuthenticatedDashboardAdminRightsRoute
  AuthenticatedDashboardAdminScimRoute: typeof AuthenticatedDashboardAdminScimRoute
  AuthenticatedDashboardAdminUnoRoute: typeof AuthenticatedDashboardAdminUnoRoute
  AuthenticatedDashboardAgentsApprovalsRoute: typeof AuthenticatedDashboardAgentsApprovalsRoute
  AuthenticatedDashboardAgentsNewRoute: typeof AuthenticatedDashboardAgentsNewRoute
  AuthenticatedDashboardAgentsTemplatesRoute: typeof AuthenticatedDashboardAgentsTemplatesRoute
  AuthenticatedDashboardChatsChatIdRoute: typeof AuthenticatedDashboardChatsChatIdRoute
  AuthenticatedDashboardDatasetsSpaceIdRoute: typeof AuthenticatedDashboardDatasetsSpaceIdRoute
  AuthenticatedDashboardSpacesSpaceIdRoute: typeof AuthenticatedDashboardSpacesSpaceIdRoute
  AuthenticatedDashboardTeamsTeamIdRoute: typeof AuthenticatedDashboardTeamsTeamIdRoute
  AuthenticatedDashboardAdminIndexRoute: typeof AuthenticatedDashboardAdminIndexRoute
  AuthenticatedDashboardAgentsIndexRoute: typeof AuthenticatedDashboardAgentsIndexRoute
  AuthenticatedDashboardChatsIndexRoute: typeof AuthenticatedDashboardChatsIndexRoute
  AuthenticatedDashboardDatasetsIndexRoute: typeof AuthenticatedDashboardDatasetsIndexRoute
  AuthenticatedDashboardProjectsIndexRoute: typeof AuthenticatedDashboardProjectsIndexRoute
  AuthenticatedDashboardSpacesIndexRoute: typeof AuthenticatedDashboardSpacesIndexRoute
  AuthenticatedDashboardTeamsIndexRoute: typeof AuthenticatedDashboardTeamsIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedWhatsNewRoute: AuthenticatedWhatsNewRoute,
  AuthenticatedDashboardArtifactsRoute: AuthenticatedDashboardArtifactsRoute,
  AuthenticatedDashboardAuditLogsRoute: AuthenticatedDashboardAuditLogsRoute,
  AuthenticatedDashboardComplianceRoute: AuthenticatedDashboardComplianceRoute,
  AuthenticatedDashboardFeedbackRoute: AuthenticatedDashboardFeedbackRoute,
  AuthenticatedDashboardIntegrationsRoute:
    AuthenticatedDashboardIntegrationsRoute,
  AuthenticatedDashboardMembersRoute: AuthenticatedDashboardMembersRoute,
  AuthenticatedDashboardSubscriptionRoute:
    AuthenticatedDashboardSubscriptionRoute,
  AuthenticatedProfileConnectionsRoute: AuthenticatedProfileConnectionsRoute,
  AuthenticatedProfilePreferencesRoute: AuthenticatedProfilePreferencesRoute,
  AuthenticatedProfilePresentationTemplatesRoute:
    AuthenticatedProfilePresentationTemplatesRoute,
  AuthenticatedProfileSecurityRoute: AuthenticatedProfileSecurityRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
  AuthenticatedDashboardAgentsAgentIdRouteRoute:
    AuthenticatedDashboardAgentsAgentIdRouteRouteWithChildren,
  AuthenticatedDashboardProjectsProjectIdRouteRoute:
    AuthenticatedDashboardProjectsProjectIdRouteRouteWithChildren,
  AuthenticatedDashboardAdminAgentsRoute:
    AuthenticatedDashboardAdminAgentsRoute,
  AuthenticatedDashboardAdminIntegrationsRoute:
    AuthenticatedDashboardAdminIntegrationsRoute,
  AuthenticatedDashboardAdminPresentationTemplatesRoute:
    AuthenticatedDashboardAdminPresentationTemplatesRoute,
  AuthenticatedDashboardAdminPrivateModelsRoute:
    AuthenticatedDashboardAdminPrivateModelsRoute,
  AuthenticatedDashboardAdminRightsRoute:
    AuthenticatedDashboardAdminRightsRoute,
  AuthenticatedDashboardAdminScimRoute: AuthenticatedDashboardAdminScimRoute,
  AuthenticatedDashboardAdminUnoRoute: AuthenticatedDashboardAdminUnoRoute,
  AuthenticatedDashboardAgentsApprovalsRoute:
    AuthenticatedDashboardAgentsApprovalsRoute,
  AuthenticatedDashboardAgentsNewRoute: AuthenticatedDashboardAgentsNewRoute,
  AuthenticatedDashboardAgentsTemplatesRoute:
    AuthenticatedDashboardAgentsTemplatesRoute,
  AuthenticatedDashboardChatsChatIdRoute:
    AuthenticatedDashboardChatsChatIdRoute,
  AuthenticatedDashboardDatasetsSpaceIdRoute:
    AuthenticatedDashboardDatasetsSpaceIdRoute,
  AuthenticatedDashboardSpacesSpaceIdRoute:
    AuthenticatedDashboardSpacesSpaceIdRoute,
  AuthenticatedDashboardTeamsTeamIdRoute:
    AuthenticatedDashboardTeamsTeamIdRoute,
  AuthenticatedDashboardAdminIndexRoute: AuthenticatedDashboardAdminIndexRoute,
  AuthenticatedDashboardAgentsIndexRoute:
    AuthenticatedDashboardAgentsIndexRoute,
  AuthenticatedDashboardChatsIndexRoute: AuthenticatedDashboardChatsIndexRoute,
  AuthenticatedDashboardDatasetsIndexRoute:
    AuthenticatedDashboardDatasetsIndexRoute,
  AuthenticatedDashboardProjectsIndexRoute:
    AuthenticatedDashboardProjectsIndexRoute,
  AuthenticatedDashboardSpacesIndexRoute:
    AuthenticatedDashboardSpacesIndexRoute,
  AuthenticatedDashboardTeamsIndexRoute: AuthenticatedDashboardTeamsIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface AuthRouteRouteChildren {
  AuthJoinRoute: typeof AuthJoinRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthOauthRoute: typeof AuthOauthRoute
  AuthRecoverRoute: typeof AuthRecoverRoute
  AuthResetRoute: typeof AuthResetRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthStartSignupRoute: typeof AuthStartSignupRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthJoinRoute: AuthJoinRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthOauthRoute: AuthOauthRoute,
  AuthRecoverRoute: AuthRecoverRoute,
  AuthResetRoute: AuthResetRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthStartSignupRoute: AuthStartSignupRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  DeviceRoute: DeviceRoute,
  OnboardingRoute: OnboardingRoute,
  PricingRoute: PricingRoute,
  SuspendedRoute: SuspendedRoute,
  OpenArtifactArtifactIdRoute: OpenArtifactArtifactIdRoute,
  SharedTokenRoute: SharedTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
